import ChairIcon from '@mui/icons-material/Chair'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import SearchIcon from '@mui/icons-material/Search'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Checkbox,
  FormControl,
  Select as MuiSelect,
  Paper,
  Typography,
  DialogTitle,
  DialogContent,
  Box,
  Card,
  CardContent,
  Chip,
  Divider,
  IconButton,
  CircularProgress,
  Grid2,
  useMediaQuery,
  useTheme,
  TextField,
} from '@mui/material'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(customParseFormat)
import {
  forwardRef,
  lazy,
  Suspense,
  useContext,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from 'react'
import { OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'
import { components } from 'react-select'
import { toast } from 'react-toastify'
import {
  getCPDataWithParams,
  getCPDataWithoutParams,
  postCPDataWithoutParams,
  putCPDataWithoutParams,
  putCPDataWithParams,
} from 'src/clinic/services'
import {
  BLANK_PATIENT_DATA,
  BOOKING_REQUEST_STATUS,
  currency_list,
  GENDER_LIST_OFFLINE,
  MOMENT_FORMATS,
  OFFLINE_PAYMENT_METHODS_LIST,
  platformOptions,
  RELATIONSHIP_OPTIONS,
  SESSION_PLATFORM_OFFLINE,
  SESSION_PLATFORM_ONLINE,
} from 'src/consumer/constants'
import { getAgeFromDobWithTime } from 'src/consumer/helpers/profilePageHelper'
import {
  ensurePlusPrefix,
  removePlusFromBeginning,
  validateEmail,
  validateName,
  validateOnlyNumbers,
  formatPhoneNumber,
} from 'src/consumer/helpers/utilFunctions'
import { platformWeb } from 'src/consumer/services'
import {
  NewEventTypeButton,
  StyledEventsRefreshIcon,
} from 'src/mentor/components/MentorEventsPage/MentorEventsPageStyles'
import {
  FilterTag,
  ActionButton,
} from 'src/clinic/components/ClinicManageBookingsPage/ClinicManageBookingsPageStyles'
import {
  getCurrencyObject,
  getDataMapFromCommonResponse,
  getDefaultScheduleFromSchedules,
  getSubscriptionPlanById,
  isCommonResponseSuccessful,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { GenericDisplayFlex } from 'src/mentor/layout/Styles'
import { v4 as uuidv4 } from 'uuid'
import PatientFormComponentV2 from 'src/clinic/components/ClinicManageBookingsPage/patientForm/PatientFormComponentV2'
import {
  buildPatientUpsertPayload,
  normalizePatientInfoForForm,
} from 'src/clinic/components/ClinicManageBookingsPage/patientForm/utils/patientFormDataUtils'
import { hasValidPatientAgeInput } from 'src/clinic/components/ClinicManageBookingsPage/patientForm/utils/patientAgeUtils'
import {
  generateAumhumLocalMailIdForUser,
  getInitiallySelectedEventTypeData,
} from './ClinicManageBookingsHelper'
import {
  BookingRequestContainer,
  BookingRequestItemsParent,
  CashDenominationInput,
  CashDenominationText,
  EDVCBookNewSlotSelect,
  EDVCEventsContainer,
  EDVCPhoneInput,
  EDVCRectangleButton,
  PIFormSection,
  PISectionInput,
  PISectionTitle,
  PISectionValidation,
  RRBContainer,
  RRBItem,
} from './ClinicManageBookingsPageStyles'

import Groups from '@mui/icons-material/Groups'
import { default as CloseIcon } from '@mui/icons-material/Close'
import DoNotDisturb from '@mui/icons-material/DoNotDisturb'
import Person from '@mui/icons-material/Person'
import Phone from '@mui/icons-material/Phone'
import Email from '@mui/icons-material/Email'
import LocationOn from '@mui/icons-material/LocationOn'
import CalendarToday from '@mui/icons-material/CalendarToday'
import Edit from '@mui/icons-material/Edit'
import Badge from '@mui/icons-material/Badge'
import Language from '@mui/icons-material/Language'
import Note from '@mui/icons-material/Note'
import PersonAdd from '@mui/icons-material/PersonAdd'
import LocalHospital from '@mui/icons-material/LocalHospital'
import AccessTime from '@mui/icons-material/AccessTime'
import LocalOffer from '@mui/icons-material/LocalOffer'
import { Button as MuiButton } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import MenuItem from '@mui/material/MenuItem'
import { styled as muiStyled } from '@mui/material/styles'
import { isValidPhoneNumber } from 'react-phone-number-input'
import {
  CustomHTMLSelect,
  CustomSelect,
  GenericLoadingOverlay,
  selectTypes,
} from 'src/consumer/components/helperComponents'
import { CustomAsyncCreatablePaginate } from 'src/consumer/components/helperComponents/dynamic'
import { cancelBookingRequestFuncForAssistant, cancelBookedSession } from 'src/consumer/services/featureServices'
import { putSPDataWithoutParams } from 'src/supportPortal/services/services'
import './LoaderComponent.css'
import { CompositeBookingRequestCreation } from './TherapyRequestBookingComponents'
import {
  cmbcCustomNoOptionsMessageComponentFunction,
  cmbcCustomResetClearFuncComponent,
} from './clinicBookingUtils.jsx'

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import VideoCameraFrontIcon from '@mui/icons-material/VideoCameraFront'
import { PinEntryVarOne } from 'src/chamberScreen/layout/PinEntryVarOne'
import {
  buildPatientDataForSelectingForNewBookingCalendar,
  isPatientEmailValid,
  isPatientMobileValid,
} from 'src/clinic/components/ClinicManageBookingsPage/newBookingCalendarUtils'
import { UnsecureSetupContext } from 'src/consumer/context/UnsecureSetupContext'
import { MUIThemeConfig } from 'src/context/MUIThemeConfig'
import { addOrUpdatePatientsInIdb } from 'src/emr/database/indexedDbDao'
import { PMPSectionInputLabel } from 'src/mentor/components/PrescriptionMakingPage/PrescriptionMakingPageStyles'
import { isVitalObjectValid } from 'src/mentor/components/VitalsListingPage/vitalTrendConfig'
import { VitalShowingComponent } from 'src/mentor/components/VitalsListingPage/VitalShowingComponent'
import { VitalsComponentEntryDialog } from './VitalsComponentEntryDialog'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import '../../../mentor/components/PrescriptionMakingPage/pmp.css'
import { PastBookingsHorizontalComponent } from './PastBookingsHorizonal'
import { getPatientVitalForBookedEvent } from './utils'
import PatientTagsComponent from './patientTags/PatientTagsComponent'

const GenericEventBookingComponent = lazy(() =>
  import('src/consumer/components/EventBooking/BookingComponents').then((module) => ({
    default: module.GenericEventBookingComponent,
  })),
)

// Import parsePhoneNumber at the top of the file
import { parsePhoneNumber } from 'libphonenumber-js'

export const CMBCBootstrapDialog = muiStyled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}))

export const CMBCBootStrapDialogPaperComponent = muiStyled(Paper)(
  ({ theme }) => `
    max-width: 700px !important;
    width: 100% !important;
    margin: 0!important;
    max-height: 100vh !important;
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    @media (max-width: 768px) {
      max-width: 100% !important;
      margin: 0 !important;
      border-radius: 0 !important;
      height: 100vh !important;
      max-height: 100vh !important;
    }
    @media (min-width: 769px) and (max-width: 979px) {
      max-width: 90% !important;
      margin: 16px auto !important;
      max-height: calc(100vh - 32px) !important;
    }
    @media (min-width: 980px) {
      max-height: calc(100% - 64px)!important;
      position: absolute !important;
      top: 16px;
    }
    `,
)

// new stuff components:

export const TherapyBookingDialogComponent = ({
  open,
  clinicLocationId,
  clinicBrandId,
  clinicLocationData,
  handleCloseDialog,
  data,
  bookingRequestsData,
  bookingRequestsDataLoading,
  setFetchDataTriggerForBookingRequests,
}) => {
  return (
    <CMBCBootstrapDialog
      onClose={handleCloseDialog}
      aria-labelledby="customized-dialog-title"
      open={open}
      PaperComponent={CMBCBootStrapDialogPaperComponent}
    >
      <div style={{ width: '90vw', height: '90vh', padding: '20px' }}>
        <CompositeBookingRequestCreation
          clinicLocationId={clinicLocationId}
          clinicBrandId={clinicBrandId}
          clinicLocationData={clinicLocationData}
          bookedSlot={data?.bookedSlot}
          bookingRequestsData={bookingRequestsData}
          bookingRequestsDataLoading={bookingRequestsDataLoading}
          neededTherapyBookingDataForThisEvent={data?.therapyBookingDataForThisEvent}
          handleCloseDialog={handleCloseDialog}
          setFetchDataTriggerForBookingRequests={setFetchDataTriggerForBookingRequests}
        />
      </div>
    </CMBCBootstrapDialog>
  )
}

export const EditBookingDialogComponent = ({
  open,
  forMentor,
  bookedEvent,
  closeFunction,
  callbackFunctionAfterSave,
  cancelAppointmentApiSignature,
  editBookingApiSignature,
  showRescheduleAction = false,
  onRescheduleBooking,
}) => {
  const PAGE_STATE_PIN = 'pin'
  const PAGE_STATE_EDIT = 'edit'
  const ACTION_CHANGE_FEE = 'changeFee'
  const ACTION_CANCEL = 'cancel'
  const ACTION_RESCHEDULE = 'reschedule'

  const [pageState, setPageState] = useState(PAGE_STATE_PIN)
  const [activeAction, setActiveAction] = useState(ACTION_CHANGE_FEE)
  const [newFee, setNewFee] = useState(bookedEvent?.feePaid || 0)
  const [feeError, setFeeError] = useState('')
  const [showCancelConfirm, setShowCancelConfirm] = useState(false)
  const [cancelReason, setCancelReason] = useState('')
  const [refundType, setRefundType] = useState('none')
  const [updating, setUpdating] = useState(false)

  // Reset state when dialog opens
  useEffect(() => {
    if (open) {
      setPageState(PAGE_STATE_PIN)
      setActiveAction(ACTION_CHANGE_FEE)
      setNewFee(bookedEvent?.feePaid || 0)
      setFeeError('')
      setShowCancelConfirm(false)
      setCancelReason('')
      setRefundType('none')
    }
  }, [open, bookedEvent?.feePaid])

  // Validate fee input
  const validateFee = (value) => {
    const numValue = parseFloat(value)
    if (isNaN(numValue) || numValue < 0) {
      setFeeError('Fee must be a valid positive number')
      return false
    }
    if (numValue > 1000000) {
      setFeeError('Fee cannot exceed 1,000,000')
      return false
    }
    setFeeError('')
    return true
  }

  const handleFeeChange = (e) => {
    const value = e.target.value
    setNewFee(value)
    if (value) {
      validateFee(value)
    } else {
      setFeeError('Fee is required')
    }
  }

  async function updateNow(newStatus) {
    // Validation
    if (!newStatus && !validateFee(newFee)) {
      return
    }

    if (newStatus === 'cancelled' && !showCancelConfirm) {
      setShowCancelConfirm(true)
      return
    }

    setUpdating(true)
    try {
      let response

      // Handle cancellation - use cancel API if provided, otherwise use edit API
      if (newStatus === 'cancelled') {
        if (cancelAppointmentApiSignature) {
          // Use dedicated cancel API
          const eventIdToCancel = bookedEvent?.id || bookedEvent?.bookedEventId
          const eventSlugToCancel = bookedEvent?.slug
          if (!eventIdToCancel && !eventSlugToCancel) {
            toast.error('Invalid booking: missing event ID or slug')
            setUpdating(false)
            return
          }
          response = await cancelBookedSession(
            cancelAppointmentApiSignature,
            eventIdToCancel,
            cancelReason?.trim() || null, // reason
            refundType, // refundType
            eventSlugToCancel // slug
          )
        } else {
          // Fallback to edit API for cancellation
          const dataToSubmit = {
            apiParam: 'booked-event-info',
            id: bookedEvent?.id,
            feePaid: parseFloat(newFee) || 0,
            status: 'cancelled',
          }
          // Detect portal and use appropriate service
          const isSupportPortal = editBookingApiSignature?.includes('/api/secure/cc/support/')
          if (isSupportPortal) {
            response = await putSPDataWithoutParams(editBookingApiSignature || '/api/secure/cc/support/events/edit', dataToSubmit)
          } else {
            response = await putCPDataWithoutParams(editBookingApiSignature || `/api/secure/meeting/edit`, dataToSubmit)
          }
        }
      } else {
        // Handle fee update - use edit API
        const dataToSubmit = {
          apiParam: 'booked-event-info',
          id: bookedEvent?.id,
          feePaid: parseFloat(newFee) || 0,
        }
        // Detect portal and use appropriate service
        const isSupportPortal = editBookingApiSignature?.includes('/api/secure/cc/support/')
        if (isSupportPortal) {
          response = await putSPDataWithoutParams(editBookingApiSignature || '/api/secure/cc/support/events/edit', dataToSubmit)
        } else {
          response = await putCPDataWithoutParams(editBookingApiSignature || `/api/secure/meeting/edit`, dataToSubmit)
        }
      }

      setUpdating(false)
      const isSuccess = response?.status === 200 && (
        isCommonResponseSuccessfulV2(response) || 
        isCommonResponseSuccessful(response?.data?.code)
      )
      if (isSuccess) {
        toast.success(newStatus === 'cancelled' ? 'Booking cancelled successfully' : 'Fee updated successfully')
        setShowCancelConfirm(false)
        setCancelReason('')
        setRefundType('none')
        callbackFunctionAfterSave()
        closeFunction()
      } else {
        toast.error(response?.data?.message || 'Error updating booking')
      }
    } catch (error) {
      setUpdating(false)
      toast.error('Failed to update booking. Please try again.')
    }
  }

  const currentFee = bookedEvent?.feePaid || 0
  const feeDifference = parseFloat(newFee) - currentFee
  const currencySymbol = getCurrencyObject(bookedEvent?.currency)?.symbol || '₹'

  return (
    <>
      <CMBCBootstrapDialog
        onClose={closeFunction}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperComponent={CMBCBootStrapDialogPaperComponent}
        sx={{ width: 'auto', margin: 'auto', maxWidth: '600px' }}
      >
        <IconButton
          aria-label="close"
          onClick={closeFunction}
          sx={{
            position: 'absolute',
            top: '8px',
            right: '8px',
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>

        {pageState === PAGE_STATE_PIN && (
          <>
            <DialogTitle
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '20px 24px',
                borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.05) 0%, rgba(99, 102, 241, 0.05) 100%)',
                fontWeight: 600,
                color: '#4338ca',
              }}
            >
              Verify Access
            </DialogTitle>
            <DialogContent sx={{ padding: '24px' }}>
              <div style={{ marginBottom: '16px', textAlign: 'center' }}>
                <Typography variant="body2" sx={{ color: 'rgba(0, 0, 0, 0.6)', marginBottom: '8px' }}>
                  Editing booking for
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#4338ca' }}>
                  {bookedEvent?.userName}
                </Typography>
              </div>
              <PinEntryVarOne
                verifyPinWithApi={true}
                onSuccessFunc={() => {
                  setPageState(PAGE_STATE_EDIT)
                }}
              />
            </DialogContent>
          </>
        )}

        {pageState === PAGE_STATE_EDIT && (
          <>
            <DialogTitle
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '20px 24px',
                borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.05) 0%, rgba(99, 102, 241, 0.05) 100%)',
              }}
            >
              <Typography component="span" sx={{ fontWeight: 600, color: '#4338ca', fontSize: '1.25rem' }}>
                Edit Booking
              </Typography>
              <Typography component="span" variant="body2" sx={{ color: 'rgba(0, 0, 0, 0.6)' }}>
                {bookedEvent?.userName}
              </Typography>
            </DialogTitle>

            <DialogContent sx={{ padding: '24px' }}>
              {/* Action Tabs */}
              <div
                style={{
                  display: 'flex',
                  gap: '8px',
                  marginBottom: '24px',
                  borderBottom: '2px solid rgba(0, 0, 0, 0.08)',
                }}
              >
                <Button
                  variant={activeAction === ACTION_CHANGE_FEE ? 'contained' : 'outlined'}
                  onClick={() => setActiveAction(ACTION_CHANGE_FEE)}
                  sx={{
                    flex: 1,
                    textTransform: 'none',
                    fontWeight: 600,
                    borderRadius: '8px 8px 0 0',
                    borderBottom: activeAction === ACTION_CHANGE_FEE ? 'none' : '2px solid transparent',
                    background:
                      activeAction === ACTION_CHANGE_FEE
                        ? 'linear-gradient(135deg, rgba(67, 56, 202, 0.1) 0%, rgba(99, 102, 241, 0.1) 100%)'
                        : 'transparent',
                    color: activeAction === ACTION_CHANGE_FEE ? '#4338ca' : 'rgba(0, 0, 0, 0.6)',
                    '&:hover': {
                      background:
                        activeAction === ACTION_CHANGE_FEE
                          ? 'linear-gradient(135deg, rgba(67, 56, 202, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%)'
                          : 'rgba(0, 0, 0, 0.04)',
                    },
                  }}
                >
                  Change Fee
                </Button>
                <Button
                  variant={activeAction === ACTION_CANCEL ? 'contained' : 'outlined'}
                  onClick={() => setActiveAction(ACTION_CANCEL)}
                  sx={{
                    flex: 1,
                    textTransform: 'none',
                    fontWeight: 600,
                    borderRadius: '8px 8px 0 0',
                    borderBottom: activeAction === ACTION_CANCEL ? 'none' : '2px solid transparent',
                    background:
                      activeAction === ACTION_CANCEL
                        ? 'linear-gradient(135deg, rgba(220, 38, 38, 0.1) 0%, rgba(239, 68, 68, 0.1) 100%)'
                        : 'transparent',
                    color: activeAction === ACTION_CANCEL ? '#dc2626' : 'rgba(0, 0, 0, 0.6)',
                    '&:hover': {
                      background:
                        activeAction === ACTION_CANCEL
                          ? 'linear-gradient(135deg, rgba(220, 38, 38, 0.15) 0%, rgba(239, 68, 68, 0.15) 100%)'
                          : 'rgba(0, 0, 0, 0.04)',
                    },
                  }}
                >
                  Cancel Booking
                </Button>
                {showRescheduleAction && (
                  <Button
                    variant={activeAction === ACTION_RESCHEDULE ? 'contained' : 'outlined'}
                    onClick={() => setActiveAction(ACTION_RESCHEDULE)}
                    sx={{
                      flex: 1,
                      textTransform: 'none',
                      fontWeight: 600,
                      borderRadius: '8px 8px 0 0',
                      borderBottom: activeAction === ACTION_RESCHEDULE ? 'none' : '2px solid transparent',
                      background:
                        activeAction === ACTION_RESCHEDULE
                          ? 'linear-gradient(135deg, rgba(245, 158, 11, 0.12) 0%, rgba(251, 191, 36, 0.12) 100%)'
                          : 'transparent',
                      color: activeAction === ACTION_RESCHEDULE ? '#b45309' : 'rgba(0, 0, 0, 0.6)',
                      '&:hover': {
                        background:
                          activeAction === ACTION_RESCHEDULE
                            ? 'linear-gradient(135deg, rgba(245, 158, 11, 0.18) 0%, rgba(251, 191, 36, 0.18) 100%)'
                            : 'rgba(0, 0, 0, 0.04)',
                      },
                    }}
                  >
                    Reschedule
                  </Button>
                )}
              </div>

              {/* Change Fee Section */}
              {activeAction === ACTION_CHANGE_FEE && (
                <div>
                  <Typography variant="subtitle2" sx={{ marginBottom: '16px', color: 'rgba(0, 0, 0, 0.7)' }}>
                    Update the fee amount for this booking
                  </Typography>

                  <div style={{ marginBottom: '16px' }}>
                    <Typography variant="body2" sx={{ marginBottom: '8px', fontWeight: 500, color: 'rgba(0, 0, 0, 0.6)' }}>
                      Current Fee
                    </Typography>
                    <div
                      style={{
                        padding: '12px 16px',
                        background: 'rgba(0, 0, 0, 0.03)',
                        borderRadius: '8px',
                        border: '1px solid rgba(0, 0, 0, 0.08)',
                      }}
                    >
                      <Typography variant="h6" sx={{ fontWeight: 600, color: '#4338ca' }}>
                        {currencySymbol} {currentFee.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </Typography>
                    </div>
                  </div>

                  <div style={{ marginBottom: '16px' }}>
                    <Typography variant="body2" sx={{ marginBottom: '8px', fontWeight: 500, color: 'rgba(0, 0, 0, 0.6)' }}>
                      New Fee *
                    </Typography>
                    <div style={{ position: 'relative' }}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: '12px 16px',
                          border: feeError ? '2px solid #dc2626' : '2px solid rgba(67, 56, 202, 0.2)',
                          borderRadius: '8px',
                          background: '#fff',
                          transition: 'all 0.2s',
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            marginRight: '8px',
                            fontWeight: 600,
                            color: '#4338ca',
                          }}
                        >
                          {currencySymbol}
                        </Typography>
                        <input
                          type="number"
                          value={newFee}
                          onChange={handleFeeChange}
                          onBlur={() => validateFee(newFee)}
                          min="0"
                          step="0.01"
                          style={{
                            border: 'none',
                            outline: 'none',
                            flex: 1,
                            fontSize: '16px',
                            fontWeight: 500,
                            fontFamily: 'inherit',
                          }}
                          placeholder="0.00"
                        />
                      </div>
                      {feeError && (
                        <Typography variant="caption" sx={{ color: '#dc2626', marginTop: '4px', display: 'block' }}>
                          {feeError}
                        </Typography>
                      )}
                    </div>
                  </div>

                  {!feeError && feeDifference !== 0 && (
                    <div
                      style={{
                        padding: '12px 16px',
                        background: feeDifference > 0 ? 'rgba(16, 185, 129, 0.1)' : 'rgba(245, 158, 11, 0.1)',
                        borderRadius: '8px',
                        border: `1px solid ${feeDifference > 0 ? 'rgba(16, 185, 129, 0.2)' : 'rgba(245, 158, 11, 0.2)'}`,
                        marginBottom: '16px',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: feeDifference > 0 ? '#10b981' : '#f59e0b',
                          fontWeight: 600,
                        }}
                      >
                        {feeDifference > 0 ? '↑' : '↓'} Difference: {currencySymbol}{' '}
                        {Math.abs(feeDifference).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </Typography>
                    </div>
                  )}

                  <Button
                    variant="contained"
                    onClick={() => updateNow()}
                    disabled={updating || !!feeError || parseFloat(newFee) === currentFee}
                    fullWidth
                    sx={{
                      marginTop: '8px',
                      padding: '12px',
                      background: 'linear-gradient(135deg, #4338ca 0%, #6366f1 100%)',
                      fontWeight: 600,
                      textTransform: 'none',
                      borderRadius: '8px',
                      '&:hover': {
                        background: 'linear-gradient(135deg, #3730a3 0%, #4f46e5 100%)',
                      },
                      '&:disabled': {
                        background: 'rgba(0, 0, 0, 0.12)',
                        color: 'rgba(0, 0, 0, 0.26)',
                      },
                    }}
                  >
                    {updating ? (
                      <>
                        <Spinner size="sm" variant="light" style={{ marginRight: '8px' }} />
                        Updating...
                      </>
                    ) : (
                      'Update Fee'
                    )}
                  </Button>
                </div>
              )}

              {/* Cancel Booking Section */}
              {activeAction === ACTION_CANCEL && (
                <div>
                  {!showCancelConfirm ? (
                    <>
                      <div
                        style={{
                          padding: '16px',
                          background: 'rgba(220, 38, 38, 0.05)',
                          borderRadius: '8px',
                          border: '1px solid rgba(220, 38, 38, 0.2)',
                          marginBottom: '24px',
                        }}
                      >
                        <Typography variant="body2" sx={{ color: '#dc2626', fontWeight: 600, marginBottom: '8px' }}>
                          ⚠️ Warning: This action cannot be undone
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'rgba(0, 0, 0, 0.7)' }}>
                          Cancelling this booking will permanently mark it as cancelled. The patient will be notified, and this action cannot be reversed.
                        </Typography>
                      </div>

                      <div style={{ marginBottom: '16px' }}>
                        <Typography variant="body2" sx={{ marginBottom: '8px', fontWeight: 500, color: 'rgba(0, 0, 0, 0.6)' }}>
                          Booking Details
                        </Typography>
                        <div
                          style={{
                            padding: '12px 16px',
                            background: 'rgba(0, 0, 0, 0.03)',
                            borderRadius: '8px',
                            border: '1px solid rgba(0, 0, 0, 0.08)',
                          }}
                        >
                          <Typography variant="body2" sx={{ marginBottom: '4px' }}>
                            <strong>Patient:</strong> {bookedEvent?.userName}
                          </Typography>
                          <Typography variant="body2" sx={{ marginBottom: '4px' }}>
                            <strong>Fee:</strong> {currencySymbol} {currentFee.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </Typography>
                          {bookedEvent?.startTime && (
                            <Typography variant="body2">
                              <strong>Date:</strong> {dayjs(bookedEvent.startTime).format('DD MMM YYYY, hh:mm A')}
                            </Typography>
                          )}
                        </div>
                      </div>

                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => setShowCancelConfirm(true)}
                        disabled={updating}
                        fullWidth
                        sx={{
                          padding: '12px',
                          fontWeight: 600,
                          textTransform: 'none',
                          borderRadius: '8px',
                          background: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
                          '&:hover': {
                            background: 'linear-gradient(135deg, #b91c1c 0%, #dc2626 100%)',
                          },
                        }}
                      >
                        Cancel This Booking
                      </Button>
                    </>
                  ) : (
                    <>
                      <div
                        style={{
                          padding: '20px',
                          background: 'rgba(220, 38, 38, 0.1)',
                          borderRadius: '12px',
                          border: '2px solid #dc2626',
                          marginBottom: '24px',
                          textAlign: 'center',
                        }}
                      >
                        <Typography variant="h6" sx={{ color: '#dc2626', fontWeight: 700, marginBottom: '8px' }}>
                          ⚠️ Confirm Cancellation
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'rgba(0, 0, 0, 0.7)', marginBottom: '16px' }}>
                          Are you absolutely sure you want to cancel this booking? This action is permanent and cannot be undone.
                        </Typography>
                        <div
                          style={{
                            padding: '12px',
                            background: '#fff',
                            borderRadius: '8px',
                            marginBottom: '16px',
                          }}
                        >
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {bookedEvent?.userName}
                          </Typography>
                          <Typography variant="caption" sx={{ color: 'rgba(0, 0, 0, 0.6)' }}>
                            {currencySymbol} {currentFee.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </Typography>
                        </div>
                      </div>

                      {/* Reason Field */}
                      <div style={{ marginBottom: '20px' }}>
                        <Typography variant="body2" sx={{ 
                          fontSize: '13px',
                          fontWeight: 600,
                          color: 'rgba(0, 0, 0, 0.85)',
                          marginBottom: '8px'
                        }}>
                          Reason for Cancellation <span style={{ color: 'rgba(0, 0, 0, 0.5)', fontWeight: 400 }}>(Optional)</span>
                        </Typography>
                        <TextField
                          fullWidth
                          multiline
                          rows={4}
                          value={cancelReason}
                          onChange={(e) => setCancelReason(e.target.value)}
                          placeholder="Enter reason for cancellation..."
                          disabled={updating}
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '8px',
                            },
                          }}
                        />
                      </div>

                      {/* Refund Type Selection */}
                      <div style={{ marginBottom: '24px' }}>
                        <Typography variant="body2" sx={{ 
                          fontSize: '13px',
                          fontWeight: 600,
                          color: 'rgba(0, 0, 0, 0.85)',
                          marginBottom: '12px'
                        }}>
                          Refund Recommendation
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                          <Box
                            onClick={() => !updating && setRefundType('none')}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px',
                              cursor: updating ? 'not-allowed' : 'pointer',
                              padding: '12px',
                              borderRadius: '8px',
                              border: `2px solid ${refundType === 'none' ? 'rgba(67, 56, 202, 0.3)' : 'rgba(0, 0, 0, 0.1)'}`,
                              background: refundType === 'none' ? 'rgba(67, 56, 202, 0.05)' : 'transparent',
                              transition: 'all 0.2s ease',
                              opacity: updating ? 0.6 : 1,
                            }}
                          >
                            <input
                              type="radio"
                              name="refundType"
                              value="none"
                              checked={refundType === 'none'}
                              onChange={(e) => setRefundType(e.target.value)}
                              disabled={updating}
                              style={{ cursor: updating ? 'not-allowed' : 'pointer' }}
                            />
                            <Box>
                              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'rgba(0, 0, 0, 0.85)' }}>
                                No Refund
                              </Typography>
                              <Typography sx={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.6)', marginTop: '2px' }}>
                                Patient will not receive a refund
                              </Typography>
                            </Box>
                          </Box>
                          <Box
                            onClick={() => !updating && setRefundType('full')}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px',
                              cursor: updating ? 'not-allowed' : 'pointer',
                              padding: '12px',
                              borderRadius: '8px',
                              border: `2px solid ${refundType === 'full' ? 'rgba(67, 56, 202, 0.3)' : 'rgba(0, 0, 0, 0.1)'}`,
                              background: refundType === 'full' ? 'rgba(67, 56, 202, 0.05)' : 'transparent',
                              transition: 'all 0.2s ease',
                              opacity: updating ? 0.6 : 1,
                            }}
                          >
                            <input
                              type="radio"
                              name="refundType"
                              value="full"
                              checked={refundType === 'full'}
                              onChange={(e) => setRefundType(e.target.value)}
                              disabled={updating}
                              style={{ cursor: updating ? 'not-allowed' : 'pointer' }}
                            />
                            <Box>
                              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'rgba(0, 0, 0, 0.85)' }}>
                                Full Refund
                              </Typography>
                              <Typography sx={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.6)', marginTop: '2px' }}>
                                Recommend full refund to the patient
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </div>

                      <div style={{ display: 'flex', gap: '12px' }}>
                        <Button
                          variant="outlined"
                          onClick={() => {
                            setShowCancelConfirm(false)
                            setCancelReason('')
                            setRefundType('none')
                          }}
                          disabled={updating}
                          fullWidth
                          sx={{
                            padding: '12px',
                            fontWeight: 600,
                            textTransform: 'none',
                            borderRadius: '8px',
                            borderColor: 'rgba(0, 0, 0, 0.2)',
                          }}
                        >
                          Go Back
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          onClick={() => updateNow('cancelled')}
                          disabled={updating}
                          fullWidth
                          sx={{
                            padding: '12px',
                            fontWeight: 600,
                            textTransform: 'none',
                            borderRadius: '8px',
                            background: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
                            '&:hover': {
                              background: 'linear-gradient(135deg, #b91c1c 0%, #dc2626 100%)',
                            },
                          }}
                        >
                          {updating ? (
                            <>
                              <Spinner size="sm" variant="light" style={{ marginRight: '8px' }} />
                              Cancelling...
                            </>
                          ) : (
                            'Yes, Cancel Booking'
                          )}
                        </Button>
                      </div>
                    </>
                  )}
                </div>
              )}

              {activeAction === ACTION_RESCHEDULE && showRescheduleAction && (
                <div>
                  <div
                    style={{
                      padding: '12px 16px',
                      background: 'rgba(245, 158, 11, 0.08)',
                      borderRadius: '8px',
                      border: '1px solid rgba(245, 158, 11, 0.22)',
                      marginBottom: '16px',
                    }}
                  >
                    <Typography variant="body2" sx={{ marginBottom: '4px' }}>
                      <strong>Patient:</strong> {bookedEvent?.userName}
                    </Typography>
                    {bookedEvent?.startTime && (
                      <Typography variant="body2">
                        <strong>Current slot:</strong>{' '}
                        {dayjs(bookedEvent.startTime).format('DD MMM YYYY, hh:mm A')}
                      </Typography>
                    )}
                  </div>
                  <Button
                    variant="contained"
                    onClick={onRescheduleBooking}
                    disabled={!onRescheduleBooking || updating}
                    fullWidth
                    sx={{
                      padding: '12px',
                      background: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
                      color: '#78350f',
                      fontWeight: 700,
                      textTransform: 'none',
                      borderRadius: '8px',
                      boxShadow: 'none',
                      '&:hover': {
                        background: 'linear-gradient(135deg, #d97706 0%, #f59e0b 100%)',
                        boxShadow: 'none',
                      },
                    }}
                  >
                    Choose New Slot
                  </Button>
                </div>
              )}
            </DialogContent>
          </>
        )}
      </CMBCBootstrapDialog>
    </>
  )
}

// Styled Components for Patient Details Viewer
const InfoSectionCard = muiStyled(Card)(({ theme }) => ({
  borderRadius: '12px',
  border: '1px solid rgba(0, 0, 0, 0.08)',
  background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.95) 100%)',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
  transition: 'all 0.2s ease',
  '&:hover': {
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  },
}))

const InfoRow = muiStyled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '12px',
  padding: '12px 0',
  '&:not(:last-child)': {
    borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
  },
}))

const InfoLabel = muiStyled(Typography)(({ theme }) => ({
  minWidth: '140px',
  fontSize: '13px',
  fontWeight: 600,
  color: 'rgba(0, 0, 0, 0.6)',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
}))

const InfoValue = muiStyled(Typography)(({ theme }) => ({
  flex: 1,
  fontSize: '14px',
  fontWeight: 500,
  color: 'rgba(0, 0, 0, 0.85)',
  wordBreak: 'break-word',
}))

const SectionTitle = muiStyled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 700,
  color: '#4338ca',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  marginBottom: '12px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
}))

// Patient Details Viewer Component
const PatientDetailsViewer = ({
  patientDetails,
  loading,
  onClose,
  dialogTitle,
  patientId,
  clinicId,
  pastPatientBookingsApiSignature,
  patientTagsApiSignature,
  onEdit,
}) => {
  const genderLabel = patientDetails?.gender
    ? GENDER_LIST_OFFLINE?.find((g) => g?.value === patientDetails?.gender)?.label || patientDetails?.gender
    : null

  const age = patientDetails?.dateOfBirth ? getAgeFromDobWithTime(patientDetails.dateOfBirth) : null

  return (
    <>
      <DialogTitle
        sx={{
          padding: '24px',
          borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
          background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.05) 0%, rgba(99, 102, 241, 0.05) 100%)',
          position: 'relative',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box>
            <Typography component="span" sx={{ fontWeight: 600, color: '#4338ca', marginBottom: '4px', fontSize: '1.25rem' }}>
              {dialogTitle || 'Patient Details'}
            </Typography>
            {patientDetails?.patientNumber && (
              <Chip
                icon={<Badge sx={{ fontSize: 16 }} />}
                label={`Patient #${patientDetails.patientNumber}`}
                size="small"
                sx={{
                  background: 'rgba(67, 56, 202, 0.1)',
                  color: '#4338ca',
                  fontWeight: 600,
                  marginTop: '8px',
                }}
              />
            )}
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {onEdit && (
              <IconButton
                onClick={onEdit}
                sx={{
                  background: 'rgba(67, 56, 202, 0.1)',
                  color: '#4338ca',
                  '&:hover': {
                    background: 'rgba(67, 56, 202, 0.2)',
                  },
                }}
              >
                <Edit sx={{ fontSize: 20 }} />
              </IconButton>
            )}
            <IconButton
              onClick={onClose}
              sx={{
                color: 'rgba(0, 0, 0, 0.6)',
                '&:hover': {
                  background: 'rgba(0, 0, 0, 0.04)',
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ padding: '24px', maxHeight: 'calc(90vh - 120px)', overflowY: 'auto' }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
            <CircularProgress />
          </Box>
        ) : patientDetails ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {/* Personal Information Section */}
            <InfoSectionCard>
              <CardContent sx={{ padding: '20px !important' }}>
                <SectionTitle>
                  <Person sx={{ fontSize: 18 }} />
                  Personal Information
                </SectionTitle>
                <InfoRow>
                  <InfoLabel>
                    <Person sx={{ fontSize: 16 }} />
                    Name
                  </InfoLabel>
                  <InfoValue>{patientDetails?.name || 'Not provided'}</InfoValue>
                </InfoRow>
                {(age || genderLabel) && (
                  <InfoRow>
                    <InfoLabel>
                      <CalendarToday sx={{ fontSize: 16 }} />
                      Age / Gender
                    </InfoLabel>
                  <InfoValue>
                      {age ? `${age}` : ''}
                      {age && genderLabel ? ' • ' : ''}
                      {genderLabel || ''}
                    </InfoValue>
                  </InfoRow>
                )}
                {patientDetails?.dateOfBirth && (
                  <InfoRow>
                    <InfoLabel>
                      <CalendarToday sx={{ fontSize: 16 }} />
                      Date of Birth
                    </InfoLabel>
                    <InfoValue>
                      {dayjs.utc(patientDetails.dateOfBirth).local().format('DD MMM YYYY')}
                    </InfoValue>
                  </InfoRow>
                )}
                {patientDetails?.uhId && (
                  <InfoRow>
                    <InfoLabel>
                      <Badge sx={{ fontSize: 16 }} />
                      UHID
                    </InfoLabel>
                    <InfoValue>{patientDetails.uhId}</InfoValue>
                  </InfoRow>
                )}
              </CardContent>
            </InfoSectionCard>

            {/* Contact Information Section */}
            <InfoSectionCard>
              <CardContent sx={{ padding: '20px !important' }}>
                <SectionTitle>
                  <Phone sx={{ fontSize: 18 }} />
                  Contact Information
                </SectionTitle>
                {patientDetails?.mobile && (
                  <InfoRow>
                    <InfoLabel>
                      <Phone sx={{ fontSize: 16 }} />
                      Mobile
                    </InfoLabel>
                    <InfoValue>{patientDetails.mobile}</InfoValue>
                  </InfoRow>
                )}
                {patientDetails?.email && (
                  <InfoRow>
                    <InfoLabel>
                      <Email sx={{ fontSize: 16 }} />
                      Email
                    </InfoLabel>
                    <InfoValue>{patientDetails.email}</InfoValue>
                  </InfoRow>
                )}
                {patientDetails?.altMobiles &&
                  Array.isArray(patientDetails.altMobiles) &&
                  patientDetails.altMobiles.length > 0 && (
                    <InfoRow>
                      <InfoLabel>
                        <Phone sx={{ fontSize: 16 }} />
                        Alternative Numbers
                      </InfoLabel>
                      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        {patientDetails.altMobiles.map((altMobile, index) => (
                          <InfoValue key={index}>{altMobile}</InfoValue>
                        ))}
                      </Box>
                    </InfoRow>
                  )}
                {patientDetails?.defaultCommunicationLanguage && (
                  <InfoRow>
                    <InfoLabel>
                      <Language sx={{ fontSize: 16 }} />
                      Preferred Language
                    </InfoLabel>
                    <InfoValue>{patientDetails.defaultCommunicationLanguage}</InfoValue>
                  </InfoRow>
                )}
              </CardContent>
            </InfoSectionCard>

            {/* Address Information Section */}
            {(patientDetails?.location?.address ||
              patientDetails?.location?.city ||
              patientDetails?.location?.pincode) && (
              <InfoSectionCard>
                <CardContent sx={{ padding: '20px !important' }}>
                  <SectionTitle>
                    <LocationOn sx={{ fontSize: 18 }} />
                    Address
                  </SectionTitle>
                  {patientDetails?.location?.address && (
                    <InfoRow>
                      <InfoLabel>Address</InfoLabel>
                      <InfoValue>{patientDetails.location.address}</InfoValue>
                    </InfoRow>
                  )}
                  {(patientDetails?.location?.city || patientDetails?.location?.pincode) && (
                    <InfoRow>
                      <InfoLabel>City / Pincode</InfoLabel>
                      <InfoValue>
                        {patientDetails?.location?.city || ''}
                        {patientDetails?.location?.city && patientDetails?.location?.pincode ? ' • ' : ''}
                        {patientDetails?.location?.pincode || ''}
                      </InfoValue>
                    </InfoRow>
                  )}
                </CardContent>
              </InfoSectionCard>
            )}

            {/* Medical & Additional Information Section */}
            {(patientDetails?.referredBy || patientDetails?.note) && (
              <InfoSectionCard>
                <CardContent sx={{ padding: '20px !important' }}>
                  <SectionTitle>
                    <LocalHospital sx={{ fontSize: 18 }} />
                    Medical & Additional Information
                  </SectionTitle>
                  {patientDetails?.referredBy && (
                    <InfoRow>
                      <InfoLabel>
                        <PersonAdd sx={{ fontSize: 16 }} />
                        Referred By
                      </InfoLabel>
                      <InfoValue>{patientDetails.referredBy}</InfoValue>
                    </InfoRow>
                  )}
                  {patientDetails?.note && (
                    <InfoRow>
                      <InfoLabel>
                        <Note sx={{ fontSize: 16 }} />
                        Notes
                      </InfoLabel>
                      <InfoValue sx={{ whiteSpace: 'pre-wrap' }}>{patientDetails.note}</InfoValue>
                    </InfoRow>
                  )}
                </CardContent>
              </InfoSectionCard>
            )}

            {/* Attendants Section */}
            {patientDetails?.attendants &&
              Array.isArray(patientDetails.attendants) &&
              patientDetails.attendants.length > 0 &&
              patientDetails.attendants.some((att) => att?.name) && (
                <InfoSectionCard>
                  <CardContent sx={{ padding: '20px !important' }}>
                    <SectionTitle>
                      <PersonAdd sx={{ fontSize: 18 }} />
                      Attendants
                    </SectionTitle>
                    {patientDetails.attendants
                      .filter((att) => att?.name)
                      .map((attendant, index) => (
                        <InfoRow key={index}>
                          <InfoLabel>
                            {attendant.primary && (
                              <Chip
                                label="Primary"
                                size="small"
                                sx={{
                                  fontSize: '9px',
                                  height: '18px',
                                  background: 'rgba(67, 56, 202, 0.1)',
                                  color: '#4338ca',
                                  fontWeight: 600,
                                  marginRight: '8px',
                                }}
                              />
                            )}
                            Attendant {index + 1}
                          </InfoLabel>
                          <Box sx={{ flex: 1 }}>
                            <InfoValue>{attendant.name}</InfoValue>
                            {attendant.type && (
                              <Typography
                                variant="caption"
                                sx={{ color: 'rgba(0, 0, 0, 0.6)', display: 'block', marginTop: '4px' }}
                              >
                                Relation:{' '}
                                {RELATIONSHIP_OPTIONS?.find((r) => r.value === attendant.type)?.label ||
                                  attendant.type}
                              </Typography>
                            )}
                          </Box>
                        </InfoRow>
                      ))}
                  </CardContent>
                </InfoSectionCard>
              )}

            {/* System Information Section */}
            <InfoSectionCard>
              <CardContent sx={{ padding: '20px !important' }}>
                <SectionTitle>
                  <AccessTime sx={{ fontSize: 18 }} />
                  System Information
                </SectionTitle>
                {patientDetails?.createdTime && (
                  <InfoRow>
                    <InfoLabel>Created</InfoLabel>
                    <InfoValue>
                      {dayjs.utc(patientDetails.createdTime).local().format('DD MMM YYYY, hh:mm:ss A')}
                    </InfoValue>
                  </InfoRow>
                )}
                {patientDetails?.modifiedTime && (
                  <InfoRow>
                    <InfoLabel>Last Modified</InfoLabel>
                    <InfoValue>
                      {dayjs.utc(patientDetails.modifiedTime).local().format('DD MMM YYYY, hh:mm:ss A')}
                    </InfoValue>
                  </InfoRow>
                )}
                {patientDetails?.status && (
                  <InfoRow>
                    <InfoLabel>Status</InfoLabel>
                    <Chip
                      label={patientDetails.status}
                      size="small"
                      color={patientDetails.status === 'active' ? 'success' : 'default'}
                      sx={{ fontWeight: 600 }}
                    />
                  </InfoRow>
                )}
              </CardContent>
            </InfoSectionCard>

            {/* Patient Tags Section */}
            {patientId && patientTagsApiSignature && (
              <InfoSectionCard>
                <CardContent sx={{ padding: '20px !important' }}>
                  <SectionTitle>
                    <LocalOffer sx={{ fontSize: 18 }} />
                    Tags
                  </SectionTitle>
                  <PatientTagsComponent
                    patientId={patientId}
                    patientTagsApiSignature={patientTagsApiSignature}
                    initialTags={patientDetails?.tags || []}
                    compact={false}
                    onTagsUpdated={(updatedTags) => {
                      // Update patient details with new tags if needed
                    }}
                  />
                </CardContent>
              </InfoSectionCard>
            )}

            {/* Past Bookings Section */}
            {patientId && clinicId && (
              <Box sx={{ marginTop: '8px' }}>
                <PastBookingsHorizontalComponent 
                  patientId={patientId} 
                  clinicId={clinicId}
                  pastPatientBookingsApiSignature={pastPatientBookingsApiSignature}
                />
              </Box>
            )}
          </Box>
        ) : (
          <Box sx={{ textAlign: 'center', padding: '40px', color: 'rgba(0, 0, 0, 0.5)' }}>
            <Typography variant="body1">No patient details found</Typography>
          </Box>
        )}
      </DialogContent>
    </>
  )
}

export const EditPatientDialogComponent = ({
  dialogTitle,
  open,
  handleCloseDialog,
  patientId,
  clinicId,
  clinicBrandId,
  mentorProfileData,
  clinicBrandData,
  importedFromItems,
  patientSearchApiSignature = '/api/secure/mentor/patient/list',
  pastPatientBookingsApiSignature,
  patientUpdateApiSignature,
  patientTagsApiSignature,
}) => {
  const [patientDetails, setPatientDetails] = useState(null)
  const [loading, setLoading] = useState(false)
  const [editMode, setEditMode] = useState(false)

  useEffect(() => {
    if (open && patientId) {
      fetchPatientDetails()
      setEditMode(false) // Reset edit mode when dialog opens
    }
  }, [open, patientId])

  async function fetchPatientDetails() {
    setLoading(true)
    try {
      const response = await getCPDataWithoutParams(
        `${patientSearchApiSignature}?patientId=${patientId}&clinicId=${clinicId}`,
      )
      if (response?.status === 200 && response?.data?.[0]) {
        setPatientDetails(response.data[0])
      }
    } catch (error) {
      console.error('Error fetching patient details:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleEditClick = () => {
    setEditMode(true)
  }

  const handleSaveSuccess = () => {
    // Refresh patient details after save
    fetchPatientDetails()
    setEditMode(false)
  }

  const handleCancelEdit = () => {
    setEditMode(false)
    // Optionally refresh to discard any local changes
    fetchPatientDetails()
  }

  return (
    <>
      <CMBCBootstrapDialog
        onClose={() => {
          setEditMode(false)
          handleCloseDialog()
        }}
        aria-labelledby="patient-details-dialog-title"
        open={open}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '16px',
            maxHeight: '90vh',
          },
        }}
      >
        {editMode ? (
          <PatientForm
            newPatient={false}
            patientId={patientId}
            showSeparateDialogActions={true}
            clinicId={clinicId}
            clinicBrandId={clinicBrandId}
            mentorProfileData={mentorProfileData}
            clinicBrandData={clinicBrandData}
            importedFromItems={importedFromItems}
            patientSearchApiSignature={patientSearchApiSignature}
            patientUpdateApiSignature={patientUpdateApiSignature}
            initialEditMode={true}
            onSaveSuccess={handleSaveSuccess}
            onCancel={handleCancelEdit}
          />
        ) : (
        <PatientDetailsViewer
          patientDetails={patientDetails}
          loading={loading}
          onClose={handleCloseDialog}
          dialogTitle={dialogTitle}
          patientId={patientId}
          clinicId={clinicId}
          pastPatientBookingsApiSignature={pastPatientBookingsApiSignature}
          patientTagsApiSignature={patientTagsApiSignature}
          onEdit={handleEditClick}
        />
        )}
      </CMBCBootstrapDialog>
    </>
  )
}

export const PendingActionsDCDialogComponent = ({
  open,
  handleCloseDialog,
  thisBookedSlotData,
  pendingActionsOfThisPatient,
  refreshPendingActions,

  patientId,
  clinicId,
  professionalDataForNextVisit,
  scheduleForNextVisit,
  eventDataForNextVisit,

  allProfessionalsDataForAssistant,
  selectedClinic,
}) => {
  const thisBookingPendingActions = pendingActionsOfThisPatient?.filter(
    (item) => item?.bookedEventId === thisBookedSlotData?.id,
  )
  const otherBookingPendingActions = pendingActionsOfThisPatient?.filter(
    (item) => item?.bookedEventId !== thisBookedSlotData?.id,
  )

  return (
    <>
      <CMBCBootstrapDialog
        onClose={handleCloseDialog}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperComponent={CMBCBootStrapDialogPaperComponent}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Pending Actions for {thisBookedSlotData?.userName}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseDialog}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <div style={{ padding: '0 20px 20px', width: '700px' }}>
          <hr />
          <h6>This Booking&apos;s pending actions:</h6>
          <div>
            <b>{thisBookingPendingActions?.length === 0 && 'No pending actions'}</b>
          </div>
          {thisBookingPendingActions?.map((thisBookingActionItem, thisBookingActionItemIndex) => {
            return (
              <div
                key={thisBookingActionItemIndex}
                style={{ border: '1px solid #CECECE', borderRadius: '5px', marginBottom: '5px' }}
              >
                <RenderAction
                  actionItem={thisBookingActionItem}
                  actionItemIndex={thisBookingActionItemIndex}
                  refreshPendingActions={refreshPendingActions}
                  patientId={patientId}
                  clinicId={clinicId}
                  eventIdForNextBooking={eventDataForNextVisit?.uid}
                  eventDataForNextBooking={eventDataForNextVisit}
                  scheduleForThisEventNextBooking={scheduleForNextVisit}
                  professionalDataForNextVisit={professionalDataForNextVisit}
                  allProfessionalsDataForAssistant={allProfessionalsDataForAssistant}
                  selectedClinic={selectedClinic}
                />
              </div>
            )
          })}

          <hr />
          <h6>Other Bookings&apos; pending actions:</h6>
          <div>
            <b>{otherBookingPendingActions?.length === 0 && 'No pending actions'}</b>
          </div>
          {otherBookingPendingActions?.map(
            (otherBookingActionItem, otherBookingActionItemIndex) => {
              return (
                <div
                  key={otherBookingActionItemIndex}
                  style={{ border: '1px solid #CECECE', borderRadius: '5px', marginBottom: '5px' }}
                >
                  <RenderAction
                    actionItem={otherBookingActionItem}
                    actionItemIndex={otherBookingActionItemIndex}
                    refreshPendingActions={refreshPendingActions}
                    patientId={patientId}
                    clinicId={clinicId}
                    eventIdForNextBooking={eventDataForNextVisit?.uid}
                    eventDataForNextBooking={eventDataForNextVisit}
                    scheduleForThisEventNextBooking={scheduleForNextVisit}
                    professionalDataForNextVisit={professionalDataForNextVisit}
                    allProfessionalsDataForAssistant={allProfessionalsDataForAssistant}
                    selectedClinic={selectedClinic}
                  />
                </div>
              )
            },
          )}
        </div>
      </CMBCBootstrapDialog>
    </>
  )
}

export const PatientForm = ({
  newPatient,
  patientId,
  showSeparateDialogActions,
  clinicId,
  clinicBrandId,
  mentorProfileData,
  clinicBrandData,
  importedFromItems,
  patientSearchApiSignature = '/api/secure/mentor/patient/list',
  patientUpdateApiSignature,
  initialEditMode = false,
  onSaveSuccess,
  onCancel,
}) => {
  const [patientDetailsLocal, setPatientDetailsLocal] = useState({ ...BLANK_PATIENT_DATA })
  const [loading, setLoading] = useState(false)
  const [editMode, setEditMode] = useState(initialEditMode)

  async function getAndSetExistingPatientDetails() {
    setLoading(true)
    const response = await getCPDataWithoutParams(
      `${patientSearchApiSignature}?patientId=${patientId}&clinicId=${clinicId}`,
    )
    if (response.status === 200 && response?.data?.[0]) {
      const receivedPatientData = response.data[0]
      setPatientDetailsLocal(
        normalizePatientInfoForForm(receivedPatientData, {
          defaultCommunicationLanguage: clinicBrandData?.defaultCommunicationLanguage || 'en',
        }),
      )
    } else {
      toast.error("Couldn't find patient details")
    }
    setLoading(false)
  }

  async function handleEditPatientDetails() {
    const dataToSubmit = buildPatientUpsertPayload(patientDetailsLocal, {
      patientId,
      clinicId,
      clinicBrandId,
      mentorId: mentorProfileData?.id,
      includePatientNumber: true,
    })
    setLoading(true)
    
    // Use provided API signature or default to standard patient update API
    const apiEndpoint = patientUpdateApiSignature || '/api/secure/patient/update'
    
    let response = await postCPDataWithoutParams(apiEndpoint, dataToSubmit)
    if (response.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
      addOrUpdatePatientsInIdb([response?.data?.data?.patient])
      toast.success('Patient Details updated')
      if (onSaveSuccess) {
        onSaveSuccess()
      }
      setEditMode(false)
    } else {
      toast.error('Error updating patient')
    }
    setLoading(false)
  }

  async function setup() {
    getAndSetExistingPatientDetails()
  }

  useEffect(() => {
    setup()
  }, [])

  return (
    <>
      {initialEditMode && (
        <DialogTitle
          sx={{
            padding: '24px',
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
            background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.05) 0%, rgba(99, 102, 241, 0.05) 100%)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography component="span" sx={{ fontWeight: 600, color: '#4338ca', fontSize: '1.25rem' }}>
            Edit Patient Details
          </Typography>
          {onCancel && (
            <IconButton
              onClick={onCancel}
              sx={{
                color: 'rgba(0, 0, 0, 0.6)',
                '&:hover': {
                  background: 'rgba(0, 0, 0, 0.04)',
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </DialogTitle>
      )}
      {(showSeparateDialogActions || initialEditMode) && (
        <DialogActions>
          {!newPatient && !initialEditMode && (
            <MuiButton autoFocus onClick={() => setEditMode((prev) => !prev)}>
              {editMode ? 'View Mode' : 'Edit'}
            </MuiButton>
          )}
          {!newPatient && (editMode || initialEditMode) && (
            <>
              {onCancel && !initialEditMode && (
                <MuiButton onClick={onCancel}>
                  Cancel
                </MuiButton>
              )}
              <MuiButton
                color="success"
                autoFocus
                onClick={handleEditPatientDetails}
                disabled={
                  !(
                    Boolean(patientDetailsLocal?.name) &&
                    (validateEmail(patientDetailsLocal?.email) ||
                      isValidPhoneNumber(`+${patientDetailsLocal?.mobile}`)) &&
                    Boolean(patientDetailsLocal?.gender) &&
                    hasValidPatientAgeInput(patientDetailsLocal)
                  ) || loading
                }
              >
                Save changes
              </MuiButton>
            </>
          )}
        </DialogActions>
      )}
      <DialogContent dividers>
        <PatientFormComponent
          editMode={editMode}
          patientDetails={patientDetailsLocal}
          setPatientDetails={setPatientDetailsLocal}
          hideInputValidations
          isAllowedToAddImportId={clinicBrandData?.patientFormSettings?.exposePatientImportIdForm}
          isAllowedToAddUHID={clinicBrandData?.patientFormSettings?.exposePatientUhIdForm}
          importIdFieldLabel={
            importedFromItems?.find(
              (item) =>
                item?.id === clinicBrandData?.patientFormSettings?.currentlySetPatientImportIdType,
            )?.title
          }
          patientUpdateApiSignature={patientUpdateApiSignature}
        />
      </DialogContent>
    </>
  )
}

export function PatientFormComponent({
  editMode = false,
  patientDetails,
  setPatientDetails,
  hidePatientNumber = false,
  hideInputValidations = false,
  patientInputDataValidations,
  makeAnonymousPatient,
  onFindingExistingPatient,
  addRelatedPatient,
  clinicId,
  clinicBrandId,
  setMakeAnonymousPatient,
  importIdFieldLabel = 'Import Id',
  isAllowedToAddImportId = false,
  isAllowedToAddUHID = false,
  isForcingAnonymousPatient = false,
  moveEmailToMoreSettings = false,
  disablePatientSearch = false,
  dontUseMoreDetailsAccordian = false,
  autoFocusMobileField = false,
  patientSearchApiSignature = '/api/secure/mentor/patient/list',
  formUiLanguageCode = 'en',
  onChangeFormUiLanguage,
  showFormUiLanguageSelector = false,
}) {
  return (
    <PatientFormComponentV2
      editMode={editMode}
      patientDetails={patientDetails}
      setPatientDetails={setPatientDetails}
      hidePatientNumber={hidePatientNumber}
      hideInputValidations={hideInputValidations}
      makeAnonymousPatient={makeAnonymousPatient}
      onFindingExistingPatient={onFindingExistingPatient}
      addRelatedPatient={addRelatedPatient}
      clinicId={clinicId}
      clinicBrandId={clinicBrandId}
      setMakeAnonymousPatient={setMakeAnonymousPatient}
      importIdFieldLabel={importIdFieldLabel}
      isAllowedToAddImportId={isAllowedToAddImportId}
      isAllowedToAddUHID={isAllowedToAddUHID}
      isForcingAnonymousPatient={isForcingAnonymousPatient}
      moveEmailToMoreSettings={moveEmailToMoreSettings}
      disablePatientSearch={disablePatientSearch}
      dontUseMoreDetailsAccordian={dontUseMoreDetailsAccordian}
      autoFocusMobileField={autoFocusMobileField}
      patientSearchApiSignature={patientSearchApiSignature}
      formUiLanguageCode={formUiLanguageCode}
      onChangeFormUiLanguage={onChangeFormUiLanguage}
      showFormUiLanguageSelector={showFormUiLanguageSelector}
    />
  )
}

export const RectangleRadioButton = ({ options, selectedId, selectionFunction, disabled }) => {
  return (
    <RRBContainer>
      {options?.map((option) => (
        <RRBItem
          key={option?.id}
          selected={option?.id === selectedId}
          onClick={() => {
            if (!disabled) {
              selectionFunction(option?.id)
            }
          }}
        >
          {option?.label}
        </RRBItem>
      ))}
    </RRBContainer>
  )
}

export const RenderAction = ({
  actionItem,
  actionItemIndex,
  refreshPendingActions,

  patientId,
  clinicId,
  eventIdForNextBooking,
  eventDataForNextBooking,
  scheduleForThisEventNextBooking,
  professionalDataForNextVisit,

  allProfessionalsDataForAssistant,
  selectedClinic,
}) => {
  if (actionItem?.type === 'refund') {
    return (
      <PaymentAction
        actionItem={actionItem}
        actionItemIndex={actionItemIndex}
        refreshPendingActions={refreshPendingActions}
      />
    )
  } else if (actionItem?.type === 'schedule-next-visit') {
    return (
      <NextVisitAction
        actionItem={actionItem}
        actionItemIndex={actionItemIndex}
        refreshPendingActions={refreshPendingActions}
        patientId={patientId}
        clinicId={clinicId}
        eventIdForNextBooking={eventIdForNextBooking}
        eventDataForNextBooking={eventDataForNextBooking}
        scheduleForThisEventNextBooking={scheduleForThisEventNextBooking}
        professionalDataForNextVisit={professionalDataForNextVisit}
      />
    )
  } else if (actionItem?.type === 'schedule-therapy') {
    return (
      <ScheduleTherapyAction
        actionItem={actionItem}
        actionItemIndex={actionItemIndex}
        refreshPendingActions={refreshPendingActions}
        allProfessionalsDataForAssistant={allProfessionalsDataForAssistant}
        clinicId={clinicId}
        patientId={patientId}
        selectedClinic={selectedClinic}
      />
    )
  }
}

export const PaymentAction = ({ actionItem, actionItemIndex, refreshPendingActions }) => {
  const orignalPaidFee = actionItem?.actionQData?.data?.originalPrice
  const newFee = actionItem?.actionQData?.data?.discountedPrice
  const differenceAmountPaid = newFee - orignalPaidFee
  const [submitLoading, setSubmitLoading] = useState(false)

  const [apiSubmissionBody, setApiSubmissionBody] = useState({
    paymentMode: 'cash',
    currency: 'inr',
    feePaid: differenceAmountPaid,
    feePaymentMode: 'cash',
    feePaidTxnId: '',
    cashBreakUp: { 500: 0, 200: 0, 100: 0, 50: 0, 20: 0, 10: 0, 5: 0, 2: 0, 1: 0 },
  })

  async function handlePaymentActionCompleted() {
    setSubmitLoading(true)
    await putCPDataWithoutParams(
      `/api/secure/clinic-assistant/booked-event/discount-refund-complete?actionQId=${actionItem?.id}`,
      removeInvalidValuesCash(apiSubmissionBody),
    )
    await refreshPendingActions()
    setSubmitLoading(false)
  }

  const total =
    apiSubmissionBody?.cashBreakUp?.['500'] * 500 +
    apiSubmissionBody?.cashBreakUp?.['200'] * 200 +
    apiSubmissionBody?.cashBreakUp?.['100'] * 100 +
    apiSubmissionBody?.cashBreakUp?.['50'] * 50 +
    apiSubmissionBody?.cashBreakUp?.['20'] * 20 +
    apiSubmissionBody?.cashBreakUp?.['10'] * 10 +
    apiSubmissionBody?.cashBreakUp?.['5'] * 5 +
    apiSubmissionBody?.cashBreakUp?.['2'] * 2 +
    apiSubmissionBody?.cashBreakUp?.['1'] * 1

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', padding: '10px' }}>
      <div>
        <b>{actionItemIndex + 1}. Payment Action</b>
      </div>
      <div>
        Fee Paid: {actionItem?.actionQData?.data?.originalPrice} / New Fee:{' '}
        {actionItem?.actionQData?.data?.discountedPrice}
      </div>
      <div>
        <u>
          <span>{differenceAmountPaid < 0 ? 'Return Amount: ' : 'Collect Amount: '}</span>
          <span>{differenceAmountPaid < 0 ? differenceAmountPaid * -1 : differenceAmountPaid}</span>
        </u>
      </div>
      <div>
        <span>Payment Mode:</span>
        <span>
          <EDVCBookNewSlotSelect
            style={{ maxWidth: '200px', marginLeft: '5px', padding: '3px' }}
            value={apiSubmissionBody?.feePaymentMode}
            onChange={(e) =>
              setApiSubmissionBody((prev) => ({
                ...prev,
                paymentMode: e.target.value,
                feePaymentMode: e.target.value,
              }))
            }
          >
            {OFFLINE_PAYMENT_METHODS_LIST?.map((paymentMethod, paymentMethodIndex) => (
              <option value={paymentMethod.id} key={paymentMethodIndex}>
                {paymentMethod.title}
              </option>
            ))}
          </EDVCBookNewSlotSelect>
        </span>
      </div>
      {apiSubmissionBody?.feePaymentMode === 'cash' && (
        <div>
          <div>Enter Denomination: </div>

          {['500', '200', '100', '50', '20', '10', '5', '2', '1'].map((denomination) =>
            renderDenominationInput(
              denomination,
              apiSubmissionBody?.cashBreakUp?.[denomination],
              (newValue) =>
                setApiSubmissionBody((prev) => ({
                  ...prev,
                  cashBreakUp: { ...prev?.cashBreakUp, [denomination]: newValue },
                })),
            ),
          )}

          <GenericDisplayFlex>
            <CashDenominationText>Total: </CashDenominationText>
            <span
              style={{
                fontWeight: '500',
                color: `${
                  total === differenceAmountPaid || total === differenceAmountPaid * -1
                    ? 'green'
                    : 'red'
                }`,
              }}
            >
              {Boolean(total) ? total : ''}
            </span>
          </GenericDisplayFlex>
        </div>
      )}
      {apiSubmissionBody?.feePaymentMode !== 'cash' && (
        <div>
          <span>Transaction ID: </span>
          <CashDenominationInput
            style={{ width: '200px' }}
            value={apiSubmissionBody?.feePaidTxnId}
            onChange={(e) =>
              setApiSubmissionBody((prev) => ({ ...prev, feePaidTxnId: e.target.value }))
            }
          />
        </div>
      )}
      {submitLoading ? (
        <Spinner animation="border" variant="dark" size="sm" />
      ) : (
        <div style={{ display: 'flex', gap: '10px' }}>
          {/* <EDVCRectangleButton>Cancel</EDVCRectangleButton> */}
          <EDVCRectangleButton action onClick={handlePaymentActionCompleted}>
            Mark Action Completed
          </EDVCRectangleButton>
        </div>
      )}
    </div>
  )
}

export const NextVisitAction = ({
  actionItem,
  actionItemIndex,
  refreshPendingActions,
  patientId,
  clinicId,
  eventIdForNextBooking,
  eventDataForNextBooking,
  scheduleForThisEventNextBooking,
  professionalDataForNextVisit,
}) => {
  const [bookingSlotSelected, setBookingSlotSelected] = useState()
  const [planDataForSelectedEventId, setPlanDataForSelectedEventId] = useState()
  const [paymentDetail, setPaymentDetail] = useState({
    feePaid: undefined,
    feePaymentMode: 'cash',
    feePaidTxnId: '',
    feeCollectionNote: '',
  })
  const [bookingLoading, setBookingLoading] = useState(false)

  useEffect(() => {
    ;(async () => {
      const eventDataForSelectedEventType = professionalDataForNextVisit?.eventTypes?.find(
        (eventType) => eventType?.uid === eventIdForNextBooking,
      )
      if (eventDataForSelectedEventType && !eventDataForSelectedEventType?.free) {
        const response = await getSubscriptionPlanById(
          eventDataForSelectedEventType?.subscriptionPlanId,
        )
        if (response.status === 200 && response?.data) {
          setPlanDataForSelectedEventId(response?.data)
        }
      } else {
        setPlanDataForSelectedEventId(null)
      }
    })()
  }, [])

  const {
    creditsContext: nextVisitCreditsContext,
    creditsContextLoading: nextVisitCreditsContextLoading,
  } = useBookingCreditsContext({
    patientId,
    subscriptionPlanId: eventDataForNextBooking?.subscriptionPlanId,
    eventTypeId: eventDataForNextBooking?.uid,
    eventType: eventDataForNextBooking?.type,
    mentorId: professionalDataForNextVisit?.id,
    clinicId,
  })

  const askPayment = Boolean(
    Boolean(planDataForSelectedEventId?.finalPrice) && !eventDataForNextBooking?.free,
  )

  return (
    <div style={{ padding: '10px' }}>
      <div>
        <b>{actionItemIndex + 1}. Next Visit Action</b>
      </div>
      <div style={{ marginBottom: '20px' }}>
        Suggested Next Visit: {dayjs(actionItem?.actionQData?.nextVisitDate)?.format('DD-MM-YYYY')}
      </div>
      <Suspense fallback={<CircularProgress size={24} />}>
        <GenericEventBookingComponent
          key={eventIdForNextBooking}
          eventId={eventIdForNextBooking}
          scheduleForThisEvent={scheduleForThisEventNextBooking}
          professionalData={professionalDataForNextVisit}
          getSelectionDetailFunction={(data) => setBookingSlotSelected(data)}
        />
      </Suspense>
      {bookingSlotSelected && (
        <div style={{ marginTop: '30px' }}>
          {askPayment && (
            <div>
              <div>Default Fee: {planDataForSelectedEventId?.finalPrice}</div>
              <>
                <div style={{ marginTop: '5px' }}>Fee Collected</div>
                <PISectionInput
                  value={paymentDetail?.feePaid}
                  onChange={(e) =>
                    setPaymentDetail((prev) => ({ ...prev, feePaid: e.target.value }))
                  }
                />
              </>
              <>
                <div style={{ marginTop: '5px' }}>Payment Mode</div>
                <EDVCBookNewSlotSelect
                  value={paymentDetail?.feePaymentMode}
                  onChange={(e) =>
                    setPaymentDetail((prev) => ({ ...prev, feePaymentMode: e.target.value }))
                  }
                >
                  {OFFLINE_PAYMENT_METHODS_LIST?.map((paymentMethod, paymentMethodIndex) => (
                    <option value={paymentMethod.id} key={paymentMethodIndex}>
                      {paymentMethod.title}
                    </option>
                  ))}
                </EDVCBookNewSlotSelect>
              </>
              {paymentDetail?.feePaymentMode !== 'cash' && (
                <>
                  <div style={{ marginTop: '5px' }}>Transaction ID</div>
                  <PISectionInput
                    value={paymentDetail?.feePaidTxnId}
                    onChange={(e) =>
                      setPaymentDetail((prev) => ({ ...prev, feePaidTxnId: e.target.value }))
                    }
                  />
                </>
              )}
            </div>
          )}

          {bookingLoading ? (
            <Spinner animation="border" variant="dark" size="md" />
          ) : (
            <div style={{ marginTop: '10px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              {nextVisitCreditsContext?.eligible && (
                <MuiButton
                  variant="outlined"
                  color="success"
                  disabled={nextVisitCreditsContextLoading || bookingLoading}
                  onClick={() =>
                    makeBookingAssistant(
                      askPayment,
                      professionalDataForNextVisit,
                      bookingSlotSelected,
                      eventDataForNextBooking,
                      patientId,
                      clinicId,
                      actionItem,
                      paymentDetail,
                      setBookingLoading,
                      refreshPendingActions,
                      'credits',
                      nextVisitCreditsContext?.recommendedBundlePackPurchaseId || '',
                    )
                  }
                >
                  {nextVisitCreditsContextLoading ? 'Checking credits...' : 'Use Pack / Credits'}
                </MuiButton>
              )}
              <MuiButton
                variant="contained"
                disabled={(() => {
                  if (askPayment) {
                    if (paymentDetail?.feePaid && paymentDetail?.feePaymentMode) {
                      if (paymentDetail?.feePaymentMode === 'cash') {
                        return false
                      } else if (
                        paymentDetail?.feePaymentMode !== 'cash' &&
                        paymentDetail?.feePaidTxnId
                      ) {
                        return false
                      } else {
                        return true
                      }
                    } else {
                      return true
                    }
                  } else {
                    return false
                  }
                })()}
                onClick={() =>
                  makeBookingAssistant(
                    askPayment,
                    professionalDataForNextVisit,
                    bookingSlotSelected,
                    eventDataForNextBooking,
                    patientId,
                    clinicId,
                    actionItem,
                    paymentDetail,
                    setBookingLoading,
                    refreshPendingActions,
                  )
                }
              >
                Book Now
              </MuiButton>
            </div>
          )}
          {nextVisitCreditsContext?.eligible && nextVisitCreditsContext?.summary && (
            <div style={{ marginTop: '8px', fontSize: '13px', color: '#4b5563' }}>
              {nextVisitCreditsContext.summary}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export const ScheduleTherapyAction = ({
  actionItem,
  actionItemIndex,
  refreshPendingActions,

  allProfessionalsDataForAssistant,
  clinicId,
  patientId,
  selectedClinic,
}) => {
  const [eventTypesVisible, setEventTypesVisible] = useState([])
  const [selectedEventTypeId, setSelectedEventTypeId] = useState()

  const [bookingSlotSelected, setBookingSlotSelected] = useState()
  const [planDataForSelectedEventId, setPlanDataForSelectedEventId] = useState()
  const [paymentDetail, setPaymentDetail] = useState({
    feePaid: undefined,
    feePaymentMode: 'cash',
    feePaidTxnId: '',
    feeCollectionNote: '',
  })
  const [bookingLoading, setBookingLoading] = useState(false)

  const thisProfessionalData = allProfessionalsDataForAssistant?.find(
    (item) => item?.id === actionItem?.actionQData?.requestedTherapist?.id,
  )

  useEffect(() => {
    const arrayToInsert = []
    thisProfessionalData?.eventTypes?.forEach((eventTypeItem) => {
      if (eventTypeItem?.contextId === clinicId) {
        arrayToInsert.push(eventTypeItem)
      }
    })
    setEventTypesVisible(arrayToInsert)
    setSelectedEventTypeId(arrayToInsert?.[0]?.uid)
  }, [thisProfessionalData])

  const eventDataForSelectedEventType = eventTypesVisible?.find(
    (eventType) => eventType?.uid === selectedEventTypeId,
  )

  const scheduleForSelectedEventType = useMemo(() => {
    if (eventDataForSelectedEventType?.contextId === clinicId) {
      if (
        thisProfessionalData?.schedules?.some((schedule) =>
          schedule?.scopeSchedules?.includes(clinicId),
        )
      ) {
        const arrayOfAllSchedulesAssoicatedWithThisClinic = thisProfessionalData?.schedules?.filter(
          (schedule) => schedule?.scopeSchedules?.includes(clinicId),
        )
        const clinicAssociatedScheduleWithThisEventId =
          arrayOfAllSchedulesAssoicatedWithThisClinic?.find((schedule) =>
            schedule?.eventIds?.includes(clinicId),
          )
        if (clinicAssociatedScheduleWithThisEventId) {
          return clinicAssociatedScheduleWithThisEventId
        } else if (arrayOfAllSchedulesAssoicatedWithThisClinic?.length > 0) {
          return arrayOfAllSchedulesAssoicatedWithThisClinic?.[0]
        }
      } else {
        const defaultClinicSchedule = getDefaultScheduleFromSchedules(selectedClinic?.schedules)
        if (defaultClinicSchedule) {
          return defaultClinicSchedule
        }
      }
    } else {
      const scheduleWithRequestedEventId = thisProfessionalData?.schedules?.find((schedule) =>
        schedule?.eventIds?.includes(selectedEventTypeId),
      )
      if (scheduleWithRequestedEventId) {
        return scheduleWithRequestedEventId
      }
    }
  }, [thisProfessionalData, selectedEventTypeId])

  useEffect(() => {
    ;(async () => {
      const eventDataForSelectedEventType = thisProfessionalData?.eventTypes?.find(
        (eventType) => eventType?.uid === selectedEventTypeId,
      )
      if (eventDataForSelectedEventType && !eventDataForSelectedEventType?.free) {
        const response = await getSubscriptionPlanById(
          eventDataForSelectedEventType?.subscriptionPlanId,
        )
        if (response.status === 200) {
          setPlanDataForSelectedEventId(response?.data)
        }
      } else {
        setPlanDataForSelectedEventId(null)
      }
    })()
  }, [selectedEventTypeId])

  const {
    creditsContext: scheduleTherapyCreditsContext,
    creditsContextLoading: scheduleTherapyCreditsContextLoading,
  } = useBookingCreditsContext({
    patientId,
    subscriptionPlanId: eventDataForSelectedEventType?.subscriptionPlanId,
    eventTypeId: eventDataForSelectedEventType?.uid,
    eventType: eventDataForSelectedEventType?.type,
    mentorId: thisProfessionalData?.id,
    clinicId,
  })

  const askPayment = Boolean(
    Boolean(planDataForSelectedEventId?.finalPrice) && !eventDataForSelectedEventType?.free,
  )

  if (Boolean(thisProfessionalData)) {
    return (
      <div style={{ padding: '10px' }}>
        <div>
          <b>{actionItemIndex + 1}. Schedule Therapy Action</b>
        </div>
        <div style={{ marginTop: '20px' }}>With {thisProfessionalData?.name}</div>
        <div>Choose Event:</div>
        <EDVCEventsContainer>
          {eventTypesVisible?.map((eventTypeItem, eventTypeIndex) => {
            return (
              <NewEventTypeButton
                key={eventTypeIndex}
                selected={selectedEventTypeId === eventTypeItem?.uid}
                onClick={() => setSelectedEventTypeId(eventTypeItem?.uid)}
              >
                {eventTypeItem?.title}
              </NewEventTypeButton>
            )
          })}
        </EDVCEventsContainer>
        <Suspense fallback={<CircularProgress size={24} />}>
          <GenericEventBookingComponent
            key={selectedEventTypeId}
            eventId={selectedEventTypeId}
            scheduleForThisEvent={scheduleForSelectedEventType}
            professionalData={thisProfessionalData}
            getSelectionDetailFunction={(data) => setBookingSlotSelected(data)}
          />
        </Suspense>
        {bookingSlotSelected && (
          <div style={{ marginTop: '30px' }}>
            {askPayment && (
              <div>
                <div>Default Fee: {planDataForSelectedEventId?.finalPrice}</div>
                <>
                  <div style={{ marginTop: '5px' }}>Fee Collected</div>
                  <PISectionInput
                    value={paymentDetail?.feePaid}
                    onChange={(e) =>
                      setPaymentDetail((prev) => ({ ...prev, feePaid: e.target.value }))
                    }
                  />
                </>
                <>
                  <div style={{ marginTop: '5px' }}>Payment Mode</div>
                  <EDVCBookNewSlotSelect
                    value={paymentDetail?.feePaymentMode}
                    onChange={(e) =>
                      setPaymentDetail((prev) => ({ ...prev, feePaymentMode: e.target.value }))
                    }
                  >
                    {OFFLINE_PAYMENT_METHODS_LIST?.map((paymentMethod, paymentMethodIndex) => (
                      <option value={paymentMethod.id} key={paymentMethodIndex}>
                        {paymentMethod.title}
                      </option>
                    ))}
                  </EDVCBookNewSlotSelect>
                </>
                {paymentDetail?.feePaymentMode !== 'cash' && (
                  <>
                    <div style={{ marginTop: '5px' }}>Transaction ID</div>
                    <PISectionInput
                      value={paymentDetail?.feePaidTxnId}
                      onChange={(e) =>
                        setPaymentDetail((prev) => ({ ...prev, feePaidTxnId: e.target.value }))
                      }
                    />
                  </>
                )}
                <div style={{ marginTop: '5px', marginBottom: '4px', fontSize: '14px', color: '#666' }}>Note</div>
                <TextField
                  multiline
                  minRows={1}
                  maxRows={4}
                  fullWidth
                  value={paymentDetail?.feeCollectionNote || ''}
                  onChange={(e) => {
                    const sanitizedValue = e.target.value
                      .replace(/<[^>]*>/g, '') // Remove HTML tags
                      .replace(/[<>]/g, '') // Remove remaining angle brackets
                      .slice(0, 200) // Limit to 200 characters
                    setPaymentDetail((prev) => ({
                      ...prev,
                      feeCollectionNote: sanitizedValue,
                    }))
                  }}
                  inputProps={{
                    maxLength: 200,
                  }}
                  helperText={`${(paymentDetail?.feeCollectionNote || '').length}/200 characters`}
                  variant="outlined"
                  size="small"
                  placeholder="Add a note about this fee collection (optional)..."
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: '14px',
                      '& textarea': {
                        resize: 'none',
                        overflow: 'hidden !important',
                      },
                    },
                    '& .MuiFormHelperText-root': {
                      fontSize: '12px',
                      marginTop: '4px',
                    },
                  }}
                />
              </div>
            )}
            {bookingLoading ? (
              <Spinner animation="border" variant="dark" size="md" />
            ) : (
              <div style={{ marginTop: '10px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                {scheduleTherapyCreditsContext?.eligible && (
                  <MuiButton
                    variant="outlined"
                    color="success"
                    disabled={scheduleTherapyCreditsContextLoading || bookingLoading}
                    onClick={() =>
                      makeBookingAssistant(
                        askPayment,
                        thisProfessionalData,
                        bookingSlotSelected,
                        eventDataForSelectedEventType,
                        patientId,
                        clinicId,
                        actionItem,
                        paymentDetail,
                        setBookingLoading,
                        refreshPendingActions,
                        'credits',
                        scheduleTherapyCreditsContext?.recommendedBundlePackPurchaseId || '',
                      )
                    }
                  >
                    {scheduleTherapyCreditsContextLoading ? 'Checking credits...' : 'Use Pack / Credits'}
                  </MuiButton>
                )}
                <MuiButton
                  variant="contained"
                  disabled={(() => {
                    if (askPayment) {
                      if (paymentDetail?.feePaid && paymentDetail?.feePaymentMode) {
                        if (paymentDetail?.feePaymentMode === 'cash') {
                          return false
                        } else if (
                          paymentDetail?.feePaymentMode !== 'cash' &&
                          paymentDetail?.feePaidTxnId
                        ) {
                          return false
                        } else {
                          return true
                        }
                      } else {
                        return true
                      }
                    } else {
                      return false
                    }
                  })()}
                  onClick={() =>
                    makeBookingAssistant(
                      askPayment,
                      thisProfessionalData,
                      bookingSlotSelected,
                      eventDataForSelectedEventType,
                      patientId,
                      clinicId,
                      actionItem,
                      paymentDetail,
                      setBookingLoading,
                      refreshPendingActions,
                    )
                  }
                >
                  Book Now
                </MuiButton>
              </div>
            )}
            {scheduleTherapyCreditsContext?.eligible && scheduleTherapyCreditsContext?.summary && (
              <div style={{ marginTop: '8px', fontSize: '13px', color: '#4b5563' }}>
                {scheduleTherapyCreditsContext.summary}
              </div>
            )}
          </div>
        )}
      </div>
    )
  } else {
    return (
      <div style={{ padding: '10px' }}>
        <div>
          <b>{actionItemIndex + 1}. Schedule Therapy Action</b>
        </div>
        <div>Error: No Mentor Data</div>
      </div>
    )
  }
}

export const renderDenominationInput = (denomination, value, onChange) => {
  return (
    <GenericDisplayFlex>
      <CashDenominationText>{`${parseInt(denomination)} x `}</CashDenominationText>
      <CashDenominationInput
        type="number"
        value={value}
        onChange={(e) => onChange(parseInt(e.target.value))}
      />
      <span>
        {' '}
        = {Boolean(value * parseFloat(denomination)) ? value * parseFloat(denomination) : ''}
      </span>
    </GenericDisplayFlex>
  )
}

// helpers :

// Per-code remediation guidance appended to the backend message for doctor
// consultation bookings. These codes originate in the shared MeetingService and
// come back with terse messages, so we attach the "what to do / where" here.
// Codes the doctor booking controller itself returns (40021, 442, 46710, 46711,
// 4030, 7036) already carry full guidance, so they are intentionally absent.
const DOCTOR_BOOKING_ACTION_BY_CODE = {
  4110:
    'To fix: a Clinic Success Admin must approve you and grant appointment access for this clinic/brand in AUMHUM-Control-Center. Clinic Success Admins can book any clinic.',
  7054: 'To fix: select a valid patient for this booking before confirming.',
  4111: 'To fix: choose a supported payment method in the Payment section of the booking dialog.',
  467:
    'To fix: re-select the appointment type; if it keeps failing, recreate the consultation appointment type on the doctor’s Events tab.',
  468:
    'To fix: this appointment type no longer exists — recreate the consultation type on the doctor’s Events tab, then retry.',
  469: 'To fix: pick an appointment type that belongs to this doctor.',
  470: 'To fix: pick an appointment type that belongs to this doctor.',
  471:
    'To fix: confirm this doctor is associated with the selected clinic — the appointment type’s clinic does not match.',
  472:
    'To fix: confirm this doctor is associated with the selected clinic — the appointment type’s clinic does not match.',
  526: 'This is a server-side error. Please report it to engineering with the doctor, clinic and slot details.',
}

// Builds a human-actionable message for a failed booking. putCPDataWithParams
// resolves (does not throw) on failure, so `response` may be either an axios
// success response carrying a non-success CommonResponse (HTTP 200, error
// `data.code`), an axios error object (non-2xx, payload under `response.response`),
// or a raw network Error. `meetingBookApiSignature` is used only to detect the
// doctor-consultation flow so we can append doctor-specific remediation text.
export function extractBookingErrorMessage(response, meetingBookApiSignature = '') {
  const isDoctorBooking = (meetingBookApiSignature || '').includes('/doctor/')
  const axiosError = response?.response
  const payload = response?.data || axiosError?.data
  const httpStatus = response?.status || axiosError?.status
  const code = payload?.code
  const backendMessage = payload?.message || payload?.error || payload?.errorMessage

  if (backendMessage) {
    const action = isDoctorBooking ? DOCTOR_BOOKING_ACTION_BY_CODE[code] : undefined
    const base = code ? `${backendMessage} (code ${code})` : backendMessage
    return action ? `${base} ${action}` : base
  }

  if (httpStatus === 401) {
    return 'Your session has expired or you are not signed in. Please sign in again and retry.'
  }
  if (httpStatus === 403) {
    return 'You do not have permission to book consultations for this clinic. This needs a Clinic Success Admin, or a Clinic Success Manager approved for this clinic with appointment access. Roles and access are assigned in AUMHUM-Control-Center.'
  }
  if (httpStatus === 404) {
    return 'Booking service was not found (404). The booking endpoint may be misconfigured — please report this to the engineering team.'
  }
  if (httpStatus && httpStatus >= 500) {
    return `The server could not process this booking (HTTP ${httpStatus}). Please retry; if it keeps failing, report it with the clinic and slot details.`
  }
  if (response?.message) {
    return `Could not reach the booking service: ${response.message}. Check your connection and retry.`
  }
  return 'Booking failed for an unknown reason. Please retry; if it continues, share the doctor, clinic and slot details with support.'
}

// Returns an optional in-app deep link ({ label, url }) for failures a booker can
// fix from another screen. Only the doctor-consultation flow gets links, and only
// for screens inside this portal — access/role grants live in AUMHUM-Control-Center
// (a separate app) and are intentionally left as text-only guidance.
export function buildBookingErrorActionLink(response, meetingBookApiSignature = '') {
  if (!(meetingBookApiSignature || '').includes('/doctor/')) return null

  const payload = response?.data || response?.response?.data
  const code = payload?.code
  if (code == null) return null

  const pathname = typeof window !== 'undefined' ? window.location.pathname : ''
  const parts = pathname.split('/')

  const doctorsIdx = parts.indexOf('doctors')
  const mentorSlug = doctorsIdx >= 0 ? parts[doctorsIdx + 1] : null
  const doctorBaseUrl = mentorSlug ? parts.slice(0, doctorsIdx + 2).join('/') : null

  const supportHomeIdx = parts.indexOf('support-home')
  const supportBaseUrl = supportHomeIdx >= 0 ? parts.slice(0, supportHomeIdx + 1).join('/') : ''

  // Appointment-type problems → doctor's Events tab.
  if ([46710, 467, 468].includes(code) && doctorBaseUrl) {
    return { label: 'Open doctor’s Events tab', url: `${doctorBaseUrl}/events` }
  }
  // Doctor/clinic scope mismatch → doctor's clinics listing.
  if ([471, 472].includes(code) && doctorBaseUrl) {
    return { label: 'Open doctor’s clinics', url: doctorBaseUrl }
  }
  // Patient not linked to a user profile → patient management.
  if (code === 7036) {
    return { label: 'Open patient management', url: `${supportBaseUrl}/patient-management/list` }
  }
  return null
}

export async function makeBookingInDayViewCalendar(
  forMentor,
  clinicId,
  clinicBrandId,
  teacherId,
  askPayment = false,
  timingData,
  eventDetails,
  patientDetails,
  updateBookingsInCalendar,
  setNewBookingDialogOpen,
  offlinePaymentDetails,
  setBookingLoading,
  setSelectedPatient,
  setIsNewPatient,
  setNewPatientInputData,
  chosenChamberRoomId,
  tryBookingScreening,
  holdSlotAndSendPaymentLink,
  reasonDataForNotDoingScreening,
  overridePaymentGateway,
  selectedRelatedConsultationForTherapy,
  meetingBookApiSignature = `/api/secure/meeting/book`,
  returnPaymentLink = false,
  sendLinkToPatient = true,
  sendLinkToRelative = false,
  customPhonesToSendLinkTo = [],
  bundlePackPurchaseId = '',
) {
  let paymentGateway
  if (askPayment) {
    if (holdSlotAndSendPaymentLink) {
      if (returnPaymentLink) {
        paymentGateway = 'paymentLinkOnScreen'
      } else {
        paymentGateway = 'paymentLinkInitiatedByMentor'
      }
    } else {
      paymentGateway = 'paidOffline'
    }
  } else {
    paymentGateway = 'free'
  }
  if (overridePaymentGateway) {
    paymentGateway = overridePaymentGateway
  }
  console.log({ paymentGateway, returnPaymentLink })

  const clientTransactionId = uuidv4()
  const isCreditsBooking = paymentGateway === 'credits'

  const dataToSubmit = {
    apiParam: 'booked-event-info',
    mentorId: teacherId,
    userId: '',
    startTime: dayjs.utc(timingData?.startTime)?.format('YYYY-MM-DD HH:mm:ss'),
    endTime: dayjs.utc(timingData?.endTime)?.format('YYYY-MM-DD HH:mm:ss'),
    eventType: eventDetails?.type,
    chamberRoomId: chosenChamberRoomId,
    eventTypeId: eventDetails?.uid,
    subscriptionPlanId: eventDetails?.subscriptionPlanId,
    patientId: patientDetails?.id,
    id: '',
    feePaid: isCreditsBooking ? '' : askPayment ? offlinePaymentDetails?.feePaid : '',
    currency: offlinePaymentDetails?.currency || 'inr',
    feePaymentMode: isCreditsBooking ? '' : askPayment ? offlinePaymentDetails?.feePaymentMode : '',
    feePaidTxnId: isCreditsBooking ? '' : askPayment ? offlinePaymentDetails?.feePaidTxnId : '',
    feeCollectionNote: isCreditsBooking ? '' : askPayment ? (offlinePaymentDetails?.feeCollectionNote || '') : '',
    clinicId: clinicId || '',
    clinicBrandId: clinicBrandId || '',
    bookingTime: dayjs()?.format(MOMENT_FORMATS.javaInstantFormat),
    ...(bundlePackPurchaseId ? { bundlePackPurchaseId } : {}),
    screeningRequest: {
      requested: tryBookingScreening,
      reasonId: reasonDataForNotDoingScreening?.id || '',
      reason: reasonDataForNotDoingScreening?.title || '',
    },
  }

  setBookingLoading(true)
  let response
  let createdBookedEventData = null
  // distinction between clinic assistant api and mentor api

  if (forMentor) {
    response = await putCPDataWithParams(meetingBookApiSignature, dataToSubmit, {
      teacherId: teacherId,
      paymentGateway: paymentGateway,
      clientTransactionId: clientTransactionId,
      platform: platformWeb,
      paymentMethod: 'upi',
      sendPaymentLinkToPatient: sendLinkToPatient,
      sendPaymentLinkToPatientRelative: sendLinkToRelative,
      phoneNumbersToSendThePaymentLink: customPhonesToSendLinkTo.join(','),
      cancelUrl: encodeURIComponent(window.location.href),
      successUrl: encodeURIComponent(window.location.href),
    })
  } else {
    const params = {
      teacherId: teacherId,
      paymentGateway: paymentGateway,
      clientTransactionId: clientTransactionId,
      platform: platformWeb,
      paymentMethod: 'upi',
      cancelUrl: encodeURIComponent(window.location.href),
      successUrl: encodeURIComponent(window.location.href),
      bookScreeningAutomatically: tryBookingScreening,
      referenceConsultationId: selectedRelatedConsultationForTherapy,
    }
    response = await putCPDataWithParams(`/api/secure/meeting/book`, dataToSubmit, params)
  }
  setBookingLoading(false)
  if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
    toast.success('Booked session')
    createdBookedEventData = getDataMapFromCommonResponse(response)?.bookedEvent
    setSelectedPatient(null)
    setIsNewPatient(false)
    setNewPatientInputData({ ...BLANK_PATIENT_DATA })
    
    // Preserve scroll position before updating bookings to prevent page from scrolling to top
    // Save both window scroll and any container scroll positions
    const savedScrollPositions = {
      windowScrollY: window.scrollY || 0,
      documentElementScrollTop: document.documentElement.scrollTop || 0,
      bodyScrollTop: document.body.scrollTop || 0,
    }
    
    // Also try to find and save scroll position of likely scrollable containers
    // Check common container selectors first before scanning all elements
    const findScrollableContainers = () => {
      const containers = []
      const likelySelectors = [
        '[data-calendar-container="true"]',
        '.EDVCParent',
        '[style*="overflow"]',
        'main',
        '[role="main"]',
      ]
      
      // Check likely containers first
      likelySelectors.forEach((selector) => {
        try {
          const elements = document.querySelectorAll(selector)
          elements.forEach((el) => {
            const style = window.getComputedStyle(el)
            if (
              (style.overflowY === 'scroll' || style.overflowY === 'auto') &&
              el.scrollHeight > el.clientHeight &&
              el.scrollTop > 0
            ) {
              containers.push({ element: el, scrollTop: el.scrollTop })
            }
          })
        } catch (e) {
          // Ignore invalid selectors
        }
      })
      
      return containers
    }
    
    const savedContainerScrolls = findScrollableContainers()
    
    // Update bookings
    updateBookingsInCalendar?.(createdBookedEventData)
    
    // Restore scroll position after DOM updates complete
    // Use multiple attempts to ensure scroll is restored even if DOM updates are delayed
    const restoreScroll = () => {
      // Restore window/document scroll
      if (savedScrollPositions.windowScrollY > 0 || savedScrollPositions.documentElementScrollTop > 0) {
        window.scrollTo({ top: savedScrollPositions.windowScrollY, behavior: 'instant' })
        document.documentElement.scrollTop = savedScrollPositions.documentElementScrollTop
        document.body.scrollTop = savedScrollPositions.bodyScrollTop
      }
      
      // Restore container scrolls
      savedContainerScrolls.forEach(({ element, scrollTop }) => {
        if (element && typeof element.scrollTop !== 'undefined') {
          try {
            element.scrollTop = scrollTop
          } catch (e) {
            // Element might have been removed from DOM
          }
        }
      })
    }
    
    // Restore immediately and also after a delay to handle async DOM updates
    requestAnimationFrame(() => {
      restoreScroll()
      setTimeout(restoreScroll, 50)
      setTimeout(restoreScroll, 150)
    })
    
    setNewBookingDialogOpen(false)
    if (response?.data?.data?.userPaymentLink?.paymentLink) {
      try {
        navigator.clipboard.writeText(response?.data?.data?.userPaymentLink?.paymentLink)
      } catch (e) {
        console.error('Error copying payment link to clipboard', e)
      }
      toast.info('Payment Link copied to clipboard')
      if (returnPaymentLink) {
        return { ...createdBookedEventData, userPaymentLink: response?.data?.data?.userPaymentLink }
      } else {
        toast.info('Payment Link sent to client')
      }
    }
  } else {
    const bookingErrorMessage = extractBookingErrorMessage(response, meetingBookApiSignature)
    const bookingErrorLink = buildBookingErrorActionLink(response, meetingBookApiSignature)
    if (bookingErrorLink) {
      toast.error(
        <span>
          {bookingErrorMessage}{' '}
          <a
            href={bookingErrorLink.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'inherit', fontWeight: 700, textDecoration: 'underline' }}
          >
            {bookingErrorLink.label}
          </a>
        </span>,
      )
    } else {
      toast.error(bookingErrorMessage)
    }
  }
  return createdBookedEventData
}


export { loadOptionsForExistingPatient } from './patientForm/services/patientSearchService'

export function getLabelForAlreadyPatientOption(option) {
  let label = option.patientNumber ? `${option.patientNumber}: ` : ''
  const altMobiles = Array.isArray(option?.altMobiles) ? option.altMobiles.filter(Boolean) : []
  const altEmails = Array.isArray(option?.altEmails) ? option.altEmails.filter(Boolean) : []

  label = label + option?.name

  if (option?.dateOfBirth || option?.gender) {
    label += ' ('
  }
  if (option?.dateOfBirth) {
    label += getAgeFromDobWithTime(option?.dateOfBirth)
  }
  if (option?.dateOfBirth && option?.gender) {
    label += '/'
  }
  if (option?.gender) {
    label += GENDER_LIST_OFFLINE?.find((item) => item.value === option?.gender)?.label || '?'
  }
  if (option?.dateOfBirth || option?.gender) {
    label += ')'
  }
  if (option?.mobile) {
    label += `, ${option?.mobile}`
  }
  if (!option?.mobile && option?.email) {
    label += `, ${option?.email}`
  }
  if (!option?.mobile && !option?.email && altMobiles.length > 0) {
    label += `, Alt mobile: ${altMobiles[0]}`
  }
  if (!option?.mobile && !option?.email && altMobiles.length === 0 && altEmails.length > 0) {
    label += `, Alt email: ${altEmails[0]}`
  }
  return label
}

export function identifyStringUseForAutoFill(inputString) {
  if (inputString && inputString.length > 0) {
    if (validateEmail(inputString)) {
      return { isValid: true, type: 'email' }
    } else if (validateOnlyNumbers(inputString)) {
      return { isValid: true, type: 'mobile' }
    } else if (validateName(inputString)) {
      return { isValid: true, type: 'name' }
    } else {
      return { isValid: false, type: '' }
    }
  } else {
    return { isValid: false, type: '' }
  }
}

export async function handleUpdatePatientDetails(
  patientId,
  clinicId,
  clinicBrandId,
  mentorProfileData,
  patientDetailsLocal,
  setPatientUpdateLoading,
  setSelectedPatientChangesDisabled,
  patientUpdateApiSignature = '/api/secure/patient/update',
) {
  const dataToSubmit = buildPatientUpsertPayload(patientDetailsLocal, {
    patientId,
    clinicId,
    clinicBrandId,
    mentorId: mentorProfileData?.id,
    includePatientNumber: true,
  })
  setPatientUpdateLoading(true)
  let response = await postCPDataWithoutParams(patientUpdateApiSignature, dataToSubmit)
  if (response.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
    addOrUpdatePatientsInIdb([response?.data?.data?.patient])
    toast.success('Patient Details updated')
  } else {
    toast.error('Error creating new patient')
  }
  setPatientUpdateLoading(false)
  setSelectedPatientChangesDisabled(true)
}

function removeInvalidValuesCash(apiSubmissionBody) {
  const updatedCashBreakUp = {}

  for (const denomination in apiSubmissionBody.cashBreakUp) {
    const value = apiSubmissionBody.cashBreakUp[denomination]
    updatedCashBreakUp[denomination] = typeof value === 'number' && !isNaN(value) ? value : 0
  }

  return {
    ...apiSubmissionBody,
    cashBreakUp: updatedCashBreakUp,
  }
}

async function makeBookingAssistant(
  askPayment,
  professionalData,
  bookingSlotSelected,
  eventData,
  patientId,
  clinicId,
  actionItem,
  paymentDetail,
  setBookingLoading,
  refreshPendingActions,
  paymentGatewayOverride = null,
  bundlePackPurchaseId = '',
) {
  let paymentGateway
  if (paymentGatewayOverride) {
    paymentGateway = paymentGatewayOverride
  } else if (askPayment) {
    paymentGateway = 'paidOffline'
  } else {
    paymentGateway = 'free'
  }
  const clientTransactionId = uuidv4()
  const isCreditsBooking = paymentGateway === 'credits'
  const dataToSubmit = {
    apiParam: 'booked-event-info',
    mentorId: professionalData?.id,
    userId: '',
    startTime: dayjs
      .utc(bookingSlotSelected?.timeSlotItem?.startTime)
      ?.add(bookingSlotSelected?.preBufferMins, 'minutes')
      ?.format('YYYY-MM-DD HH:mm:ss'),
    endTime: dayjs
      .utc(bookingSlotSelected?.timeSlotItem?.endTime)
      ?.subtract(bookingSlotSelected?.postBufferMins, 'minutes')
      ?.format('YYYY-MM-DD HH:mm:ss'),
    eventType: eventData?.type,
    eventTypeId: eventData?.uid,
    subscriptionPlanId: eventData?.subscriptionPlanId,
    patientId: patientId,
    id: '',
    feePaid: isCreditsBooking ? '' : askPayment ? paymentDetail?.feePaid : '',
    currency: paymentDetail?.currency || 'inr',
    feePaymentMode: isCreditsBooking ? '' : askPayment ? paymentDetail?.feePaymentMode : '',
    feePaidTxnId: isCreditsBooking ? '' : askPayment ? paymentDetail?.feePaidTxnId : '',
    feeCollectionNote: isCreditsBooking ? '' : askPayment ? (paymentDetail?.feeCollectionNote || '') : '',
    clinicId: clinicId || '',
    ...(bundlePackPurchaseId ? { bundlePackPurchaseId } : {}),
  }
  setBookingLoading(true)
  let response
  // distinction between clinic assistant api and mentor api
  response = await putCPDataWithoutParams(
    `/api/secure/meeting/book?teacherId=${
      professionalData?.id
    }&paymentGateway=${paymentGateway}&clientTransactionId=${clientTransactionId}&platform=${platformWeb}&paymentMethod=upi&actionQId=${
      actionItem?.id
    }&cancelUrl=${encodeURIComponent(window.location.href)}&successUrl=${encodeURIComponent(
      window.location.href,
    )}`,
    dataToSubmit,
  )
  setBookingLoading(false)
  if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
    toast.success('Booked session')
    refreshPendingActions()
  } else {
    toast.error('Error Booking Session')
  }
}

function useBookingCreditsContext({
  patientId,
  subscriptionPlanId,
  eventTypeId,
  eventType,
  mentorId,
  clinicId,
  clinicBrandId = '',
}) {
  const [creditsContext, setCreditsContext] = useState(null)
  const [creditsContextLoading, setCreditsContextLoading] = useState(false)

  useEffect(() => {
    let active = true

    const loadCreditsContext = async () => {
      if (!patientId || !subscriptionPlanId) {
        setCreditsContext(null)
        return
      }

      setCreditsContextLoading(true)
      const response = await getCPDataWithParams('/api/secure/meeting/booking-credits-context', {
        patientId,
        subscriptionPlanId,
        eventTypeId: eventTypeId || '',
        eventType: eventType || '',
        mentorId: mentorId || '',
        clinicId: clinicId || '',
        clinicBrandId: clinicBrandId || '',
      })

      if (!active) {
        return
      }

      if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
        setCreditsContext(getDataMapFromCommonResponse(response)?.creditsContext || null)
      } else {
        setCreditsContext(null)
      }
      setCreditsContextLoading(false)
    }

    loadCreditsContext()

    return () => {
      active = false
    }
  }, [patientId, subscriptionPlanId, eventTypeId, eventType, mentorId, clinicId, clinicBrandId])

  return {
    creditsContext,
    creditsContextLoading,
  }
}

export function getOverlapDataWithPreviousSlots(bookedSlotItem, bookedSlotsPerUtc) {
  // 1 part : RN only checking if there are any slots before this booked slot,
  // having same starttime and endtime as this slot, and then using adding duration in this slot
  // 2 part : the other thing is shifting of other slots, very basic case, we can shift all slots that are below instead of checking if they need to be shifted, doing this
  // 3 part: there will be slots that will need to be shifted as they are not same starttime, endtime, but there has already been an overlap and downshift above. so we will need to push these too
  // possible bug: exact same second bookings might not show up

  const allBookingsBeforeThisBooking = bookedSlotsPerUtc?.filter((item) =>
    dayjs(item?.createdTime)?.isBefore(bookedSlotItem?.createdTime),
  )

  const sameTimeOverlapsAsThisBooking = allBookingsBeforeThisBooking?.filter(
    (item) =>
      item?.startTime === bookedSlotItem?.startTime && item?.endTime === bookedSlotItem?.endTime,
  )?.length

  let minutesToAddToThisEvent = 0

  const countMap = new Map() // Map to store counts of items with same start and end times and Iterate through the array
  allBookingsBeforeThisBooking?.forEach((item) => {
    const key = `${item.startTime}_${item.endTime}` // Create a unique key using start and end times
    if (countMap.has(key)) {
      // If the key already exists, increment the count
      countMap.set(key, countMap.get(key) + 1)
    } else {
      // If the key doesn't exist, initialize the count to 1
      countMap.set(key, 1)
    }
  })
  countMap.forEach((value, key) => {
    let additionAmount = 0
    if (`${bookedSlotItem.startTime}_${bookedSlotItem.endTime}`) {
    } else {
      if (value > 1) {
        additionAmount = value - 1
      }
      minutesToAddToThisEvent += additionAmount * bookedSlotItem?.eventDuration
    }
  })

  if (sameTimeOverlapsAsThisBooking > 0) {
    minutesToAddToThisEvent += sameTimeOverlapsAsThisBooking * bookedSlotItem?.eventDuration
  }
  return { minutesToAddToThisEvent: minutesToAddToThisEvent }
}

export const customSortForDayCalendar = (a, b) => {
  // Check if both items have 'createdTime'
  if (a?.createdTime && b?.createdTime) {
    return dayjs(a?.createdTime).diff(dayjs(b?.createdTime))
  }
  // Check if both items have 'modifiedTime'
  else if (a?.modifiedTime && b?.modifiedTime) {
    return dayjs(a?.modifiedTime).diff(dayjs(b?.modifiedTime))
  }
  // If 'createdTime' or 'modifiedTime' is missing, sort based on 'appointmentNumber'
  else {
    return a?.appointmentNumber - b?.appointmentNumber
  }
}

const BookingRequestStrip = ({ bookingRequestId, cancelClickFunction, bookingRequestData }) => {
  return (
    <BookingRequestContainer>
      {/* looking status loader */}
      {bookingRequestData?.status === BOOKING_REQUEST_STATUS.BOOKING_INITIATED && (
        <div style={{ display: 'flex', gap: '8px' }}>
          <div>Looking for therapists in {bookingRequestData?.clinicLocationName}</div>
          <div className="loader"></div>
        </div>
      )}

      {/* patient details */}
      <div>
        Patient Details:{' '}
        <b>
          {bookingRequestData?.patientName || bookingRequestData?.patientId},{' '}
          {
            GENDER_LIST_OFFLINE?.find((item) => item?.value === bookingRequestData?.patientGender)
              ?.label
          }
          ,{' '}
          {dayjs()?.diff(
            dayjs.utc(bookingRequestData?.patientDateOfBirth, 'YYYY-MM-DD HH:mm:ss'),
            'years',
          )}
          {Array.isArray(bookingRequestData?.patientLanguages) &&
            bookingRequestData?.patientLanguages?.length > 0 &&
            `, speaks ${bookingRequestData?.patientLanguages?.join(', ')}`}
        </b>
      </div>

      {/* mentor */}
      <div>Suggested by {bookingRequestData?.suggestedByMentorName}</div>

      {/* started looking */}
      <div>
        Started Looking:{' '}
        {dayjs
          .utc(bookingRequestData?.createdTime)
          ?.local()
          ?.format('DD MMM, h:mma')}
      </div>

      {/* session start time */}
      <div>
        Session Starts:{' '}
        {dayjs
          .utc(bookingRequestData?.startTime)
          ?.local()
          ?.format('DD MMM, h:mma')}
      </div>

      {/* finalised fee data */}
      {bookingRequestData?.fee && bookingRequestData?.currency && (
        <div>
          Collect Fee:{' '}
          {(
            currency_list?.find((item) => item?.code === bookingRequestData?.currency)?.code || ''
          ).toUpperCase()}{' '}
          {bookingRequestData?.fee}
        </div>
      )}

      {/* status and action buttons */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div></div>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          {bookingRequestData?.status === BOOKING_REQUEST_STATUS.BOOKING_INITIATED && (
            <button
              style={{
                background: 'red',
                color: '#fff',
                padding: '4px 8px',
                borderRadius: '4px',
              }}
              onClick={() => cancelClickFunction(bookingRequestId)}
            >
              Cancel
            </button>
          )}

          {bookingRequestData?.status === BOOKING_REQUEST_STATUS.BOOKING_CANCELLED && (
            <div style={{ fontWeight: 600, color: 'red' }}>Cancelled</div>
          )}

          {bookingRequestData?.status === BOOKING_REQUEST_STATUS.BOOKING_EXPIRED && (
            <div style={{ fontWeight: 600, color: 'red' }}>Expired</div>
          )}

          {bookingRequestData?.status === BOOKING_REQUEST_STATUS.BOOKING_ACCEPTED && (
            <div style={{ fontWeight: 600, color: 'green' }}>
              Accepted by {bookingRequestData?.acceptedByName}
            </div>
          )}
          {bookingRequestData?.status === BOOKING_REQUEST_STATUS.BOOKING_BOOKED && (
            <div className="d-flex flex-column align-items-end">
              <div style={{ fontWeight: 600, color: 'green' }}>
                Booking created with {bookingRequestData?.acceptedByName}
              </div>
              <div>
                ({platformOptions.find((item) => item.id === bookingRequestData?.mode)?.name})
              </div>
            </div>
          )}
        </div>
      </div>
    </BookingRequestContainer>
  )
}

export const AllPastBookingRequestListSection = ({
  bookingRequestsData,
  clinicLocationData,
  bookingRequestsDataLoading,
  setFetchDataTriggerForBookingRequests,
}) => {
  const [dataLoading, setDataLoading] = useState(false)

  async function cancelBookingRequest(bookingRequestId) {
    setDataLoading(true)
    await cancelBookingRequestFuncForAssistant(bookingRequestId)
    setDataLoading(false)
    setFetchDataTriggerForBookingRequests((prev) => !prev)
  }

  const tooltipComp = (
    <Tooltip id="tooltip">
      <strong>Update Therapy Booking Requests</strong>
    </Tooltip>
  )

  useEffect(() => {
    const interval = setInterval(() => {
      setFetchDataTriggerForBookingRequests((prev) => !prev)
    }, 60000) // 1 minute

    // setFetchDataTriggerForBookingRequests((prev) => !prev) // already called outside - Call initially

    return () => clearInterval(interval) // Cleanup function to clear the interval
  }, [])

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '32px' }}>
        <div>
          <div>
            <b>All Therapy Booking Requests</b>
          </div>
          <div style={{ fontSize: '12px' }}>
            (where start time of session is after{' '}
            {dayjs()?.subtract(24, 'hours')?.format('DD-MM-YYYY h:mm A')})
          </div>
        </div>
        {dataLoading ? (
          <Spinner animation="border" variant="dark" size="sm" />
        ) : (
          <OverlayTrigger placement="bottom" overlay={tooltipComp}>
            <StyledEventsRefreshIcon
              onClick={() => setFetchDataTriggerForBookingRequests((prev) => !prev)}
            />
          </OverlayTrigger>
        )}
      </div>
      <BookingRequestItemsParent>
        {(bookingRequestsDataLoading || dataLoading) && (
          <GenericLoadingOverlay
            backgroundColor={'rgba(78, 8, 122, 0.15)'}
            spinnerVariant={'dark'}
          />
        )}
        {bookingRequestsData?.map((item, index) => {
          return (
            <BookingRequestStrip
              key={index}
              bookingRequestId={item?.id}
              cancelClickFunction={cancelBookingRequest}
              bookingRequestData={item}
            />
          )
        })}
      </BookingRequestItemsParent>
    </div>
  )
}

export const PatientSearchPlaceholder = (props) => (
  <components.Placeholder {...props}>
    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      <SearchIcon style={{ fontSize: '16px' }} />
      <span style={{ display: 'flex', alignItems: 'center' }}>Search Patient</span>
    </div>
  </components.Placeholder>
)

export const CustomCreateOption = ({ innerProps, selectProps, data }) => {
  return (
    <div
      {...innerProps}
      className="custom-create-option"
      style={{
        padding: '10px 14px',
        cursor: 'pointer',
        background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(99, 102, 241, 0.08) 100%)',
        borderRadius: '10px',
        margin: '2px 0',
        border: '1.5px solid rgba(139, 92, 246, 0.4)',
        fontWeight: 600,
        fontSize: '14px',
        color: '#6b21a8',
        transition: 'all 0.2s ease',
        boxShadow: '0 2px 8px rgba(139, 92, 246, 0.1)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'linear-gradient(135deg, rgba(139, 92, 246, 0.15) 0%, rgba(99, 102, 241, 0.12) 100%)'
        e.currentTarget.style.borderColor = 'rgba(139, 92, 246, 0.6)'
        e.currentTarget.style.transform = 'translateY(-1px)'
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(139, 92, 246, 0.2)'
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(99, 102, 241, 0.08) 100%)'
        e.currentTarget.style.borderColor = 'rgba(139, 92, 246, 0.4)'
        e.currentTarget.style.transform = 'translateY(0)'
        e.currentTarget.style.boxShadow = '0 2px 8px rgba(139, 92, 246, 0.1)'
      }}
    >
      Add related patient for this number
    </div>
  )
}

export const PatientSearchCustomOption = (props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('768'))
  
  const currentOption = props.options?.find((optn) => optn?.id === props?.value)
  const isSelected = props.isSelected
  const isFocused = props.isFocused
  const patientContactDetailsVisible =
    currentOption?.responseContexts?.patientContactDetailsVisible !== false &&
    currentOption?.patientContactDetailsVisible !== false

  const relativeLabel =
    RELATIONSHIP_OPTIONS?.find(
      (item) => item?.value === currentOption?.primaryPatientProfile?.dependentRelation,
    )?.label || ''

  // Format phone number
  const phoneDetails = patientContactDetailsVisible && currentOption?.mobile ? formatPhoneNumber(currentOption.mobile) : null
  const formattedPhone = phoneDetails?.formattedPhoneNumber 
    ? `(${phoneDetails.countryCode}) ${phoneDetails.formattedPhoneNumber}`
    : phoneDetails?.concatenatedString || currentOption?.mobile
  const altMobiles = patientContactDetailsVisible && Array.isArray(currentOption?.altMobiles)
    ? currentOption.altMobiles.filter((value) => value && value !== currentOption?.mobile)
    : []
  const altEmails = patientContactDetailsVisible && Array.isArray(currentOption?.altEmails)
    ? currentOption.altEmails.filter((value) => value && value !== currentOption?.email)
    : []
  const alternativeContacts = [
    ...altMobiles.slice(0, 2).map((value) => ({ type: 'mobile', value })),
    ...altEmails.slice(0, 2).map((value) => ({ type: 'email', value })),
  ]

  // Get gender label
  const genderLabel = GENDER_LIST_OFFLINE?.find((item) => item.value === currentOption?.gender)?.label || '?'

  // Get age with detailed breakdown
  const getDetailedAge = (dob) => {
    if (!dob) return null
    try {
      const today = new Date()
      const birthDate = new Date(dob?.substring(0, 10))
      
      let years = today.getFullYear() - birthDate.getFullYear()
      let months = today.getMonth() - birthDate.getMonth()
      let days = today.getDate() - birthDate.getDate()
      
      if (days < 0) {
        months--
        const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0)
        days += lastMonth.getDate()
      }
      
      if (months < 0) {
        years--
        months += 12
      }
      
      const parts = []
      if (years > 0) parts.push(`${years} ${years === 1 ? 'Yr' : 'Yrs'}`)
      if (months > 0) parts.push(`${months} ${months === 1 ? 'Mo' : 'Mo'}`)
      if (days > 0 && years === 0) parts.push(`${days} ${days === 1 ? 'Day' : 'Days'}`)
      
      return parts.length > 0 ? parts.join(', ') : '0 Days'
    } catch (error) {
      return null
    }
  }
  
  const age = currentOption?.dateOfBirth ? getDetailedAge(currentOption.dateOfBirth) : null

  // Determine if this is a dependent/related patient
  const isDependent = !!props?.data?.primaryPatientProfile

  return (
    <components.Option 
      {...props}
      aria-label={`Patient ${currentOption?.name}, ${age ? `age ${age}` : ''}, ${genderLabel}${patientContactDetailsVisible && currentOption?.mobile ? `, phone ${formattedPhone}` : patientContactDetailsVisible && currentOption?.email ? `, email ${currentOption.email}` : ''}${isDependent ? `, ${relativeLabel}` : ', Primary patient'}`}
    >
      <div
        style={{
          padding: isMobile ? '12px 16px' : '8px 12px',
          backgroundColor: isSelected 
            ? 'rgba(67, 56, 202, 0.12)' 
            : isFocused 
            ? 'rgba(67, 56, 202, 0.06)' 
            : 'transparent',
          borderRadius: '10px',
          transition: 'all 0.2s ease',
          cursor: 'pointer',
          border: isSelected ? '1.5px solid rgba(67, 56, 202, 0.3)' : '1.5px solid transparent',
          boxShadow: isSelected ? '0 2px 8px rgba(67, 56, 202, 0.1)' : 'none',
          minHeight: isMobile ? '80px' : 'auto',
        }}
      >
        {/* First Row: Name only */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            marginBottom: isMobile ? '8px' : '4px',
          }}
        >
          {currentOption?.patientNumber && (
            <Chip
              label={`#${currentOption.patientNumber}`}
              size="small"
              sx={{
                height: isMobile ? '24px' : '20px',
                fontSize: isMobile ? '11px' : '10px',
                fontWeight: 700,
                backgroundColor: 'rgba(67, 56, 202, 0.12)',
                color: '#4338ca',
                border: '1px solid rgba(67, 56, 202, 0.25)',
                '& .MuiChip-label': {
                  padding: isMobile ? '0 8px' : '0 6px',
                },
              }}
            />
          )}
          <Typography
            variant="body1"
            sx={{
              fontSize: isMobile ? '16px' : '14px',
              fontWeight: 700,
              color: '#1e293b',
              flex: 1,
              minWidth: 0,
              wordBreak: 'break-word',
              lineHeight: 1.3,
            }}
          >
            {currentOption?.name || 'Unknown'}
          </Typography>
        </div>

        {/* Second Row: Age/Gender, Primary/Relative */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            flexWrap: 'wrap',
            marginBottom: isMobile && patientContactDetailsVisible && (currentOption?.mobile || currentOption?.email) ? '8px' : '0',
          }}
        >
          {/* Age and Gender together */}
          {(age || (genderLabel && genderLabel !== '?')) && (
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px',
                padding: isMobile ? '4px 10px' : '2px 7px',
                borderRadius: '6px',
                backgroundColor: 'rgba(100, 116, 139, 0.1)',
                fontSize: isMobile ? '13px' : '11px',
                fontWeight: 600,
                color: '#475569',
                whiteSpace: 'nowrap',
                flexShrink: 0,
              }}
            >
              {age && (
                <>
                  <CalendarToday sx={{ fontSize: isMobile ? '14px' : '11px' }} />
                  <span>{age}</span>
                </>
              )}
              {age && genderLabel && genderLabel !== '?' && (
                <span style={{ color: 'rgba(100, 116, 139, 0.4)' }}>•</span>
              )}
              {genderLabel && genderLabel !== '?' && (
                <>
                  <Person sx={{ fontSize: isMobile ? '14px' : '11px' }} />
                  <span>{genderLabel}</span>
                </>
              )}
            </Box>
          )}
          {/* Subtle Primary/Relative indicator */}
          <Typography
            variant="caption"
            sx={{
              fontSize: isMobile ? '11px' : '10px',
              fontWeight: 600,
              color: '#64748b',
              fontStyle: 'italic',
              flexShrink: 0,
            }}
          >
            {isDependent ? relativeLabel || 'Dependent' : 'Primary'}
          </Typography>
        </div>

        {/* Third Row (Mobile): Phone/Email - More prominent on mobile */}
        {patientContactDetailsVisible && (currentOption?.mobile || currentOption?.email) && (
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: isMobile ? '6px' : '6px',
              width: '100%',
            }}
          >
            {/* Phone Number */}
            {currentOption?.mobile ? (
              <Box
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: isMobile ? '6px 12px' : '3px 9px',
                  borderRadius: '6px',
                  backgroundColor: 'rgba(59, 130, 246, 0.12)',
                  fontSize: isMobile ? '14px' : '12px',
                  fontWeight: 600,
                  color: '#1e40af',
                  flex: isMobile ? 'none' : 1,
                  minWidth: 0,
                  width: isMobile ? '100%' : 'auto',
                }}
              >
                <Phone sx={{ fontSize: isMobile ? '16px' : '13px', flexShrink: 0 }} />
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: isMobile ? '14px' : '12px',
                    fontWeight: 600,
                    color: '#1e40af',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    flex: 1,
                  }}
                >
                  {formattedPhone}
                </Typography>
              </Box>
            ) : currentOption?.email ? (
              <Box
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: isMobile ? '6px 12px' : '3px 9px',
                  borderRadius: '6px',
                  backgroundColor: 'rgba(139, 92, 246, 0.12)',
                  fontSize: isMobile ? '14px' : '12px',
                  fontWeight: 600,
                  color: '#6b21a8',
                  flex: isMobile ? 'none' : 1,
                  minWidth: 0,
                  width: isMobile ? '100%' : 'auto',
                }}
              >
                <Email sx={{ fontSize: isMobile ? '16px' : '13px', flexShrink: 0 }} />
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: isMobile ? '14px' : '12px',
                    fontWeight: 600,
                    color: '#6b21a8',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    flex: 1,
                  }}
                >
                  {currentOption.email}
                </Typography>
              </Box>
            ) : null}
          </div>
        )}

        {alternativeContacts.length > 0 && (
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '6px',
              marginTop: '8px',
            }}
          >
            {alternativeContacts.map((contact, index) => (
              <Box
                key={`${contact.type}-${contact.value}-${index}`}
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: isMobile ? '5px 10px' : '3px 8px',
                  borderRadius: '999px',
                  backgroundColor:
                    contact.type === 'mobile'
                      ? 'rgba(14, 165, 233, 0.09)'
                      : 'rgba(168, 85, 247, 0.09)',
                  border:
                    contact.type === 'mobile'
                      ? '1px solid rgba(14, 165, 233, 0.16)'
                      : '1px solid rgba(168, 85, 247, 0.16)',
                }}
              >
                {contact.type === 'mobile' ? (
                  <Phone sx={{ fontSize: isMobile ? '14px' : '12px', color: '#0369a1' }} />
                ) : (
                  <Email sx={{ fontSize: isMobile ? '14px' : '12px', color: '#7e22ce' }} />
                )}
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: isMobile ? '12px' : '11px',
                    fontWeight: 600,
                    color: contact.type === 'mobile' ? '#0369a1' : '#7e22ce',
                    lineHeight: 1.3,
                  }}
                >
                  Alt {contact.type === 'mobile' ? 'mobile' : 'email'}: {contact.value}
                </Typography>
              </Box>
            ))}
          </div>
        )}
      </div>
    </components.Option>
  )
}

export function shouldShowTwoRowDesign(arr) {
  try {
    if (
      arr.some(
        (item) =>
          item?.previousSteps && Array.isArray(item.previousSteps) && item.previousSteps.length > 0,
      ) ||
      arr.some(
        (item) => item?.nextSteps && Array.isArray(item.nextSteps) && item.nextSteps.length > 0,
      )
    ) {
      return true
    }
    return false
  } catch (err) {
    return false
  }
}

export const AvailableScreenerComponent = ({ eventBeingBooked, setScreenerAvailable }) => {
  const [loading, setLoading] = useState(false)
  const [possibleSession, setPossibleSession] = useState()

  async function checkPossibleScreeningSessionForThisBooking() {
    setLoading(true)
    const response = await putCPDataWithoutParams(
      `/api/secure/meeting/screening/find-possible`,
      eventBeingBooked,
    )
    setLoading(false)
    if (
      response?.status === 200 &&
      isCommonResponseSuccessful(response?.data?.code) &&
      response?.data?.data?.screening
    ) {
      setPossibleSession(response?.data?.data?.screening)
      setScreenerAvailable(true)
    } else {
      setScreenerAvailable(false)
      setPossibleSession()
    }
  }

  useEffect(() => {
    checkPossibleScreeningSessionForThisBooking()
  }, [])

  return (
    <div>
      {loading ? (
        <Spinner animation="border" variant="dark" size="sm" />
      ) : (
        <div>
          (
          {possibleSession?.mentorName
            ? `Available: ${possibleSession?.mentorName}`
            : 'No Screener Available right now'}
          )
        </div>
      )}
    </div>
  )
}

export function getCompletedByTotalStringForEventType(bookingsArray, eventTypeData) {
  if (Array.isArray(bookingsArray) && eventTypeData) {
    const eventTypeId = eventTypeData.uid
    const relevantBookings = bookingsArray.filter((booking) => booking.eventTypeId === eventTypeId)
    const totalBookings = relevantBookings.length
    const completedBookings = relevantBookings.filter((booking) => booking?.markedCompleted).length
    return `${completedBookings}/${totalBookings}`
  }
  return ''
}

/// day cal v2:

export const EDVCFilterComponent = ({
  eventTypesVisible,
  thisClinicData,
  selectedEventTypeId,
  setSelectedEventTypeId,
  mentorProfileData,
  bookedSlotsInDay,
}) => {
  return (
    <EDVCEventsContainer>
      {eventTypesVisible?.map((eventTypeItem, eventTypeIndex) => {
        return (
          <NewEventTypeButton
            key={eventTypeIndex}
            selected={selectedEventTypeId === eventTypeItem?.uid}
            onClick={() => setSelectedEventTypeId(eventTypeItem?.uid)}
          >
            {eventTypeItem?.title}
            <span style={{ marginLeft: '8px' }}>
              {eventTypeItem?.meetingSrc === 'aumhum' ? <VideoCameraFrontIcon /> : <ChairIcon />}
            </span>
            {/* {thisEventClinic?.nickName && `(${thisEventClinic?.nickName})`}{' '} */}
            {getCompletedByTotalStringForEventType(bookedSlotsInDay, eventTypeItem) &&
              `(${getCompletedByTotalStringForEventType(bookedSlotsInDay, eventTypeItem)})`}
          </NewEventTypeButton>
        )
      })}
    </EDVCEventsContainer>
  )
}

export const EDVCSessionsCompletedDetailsComponent = ({
  bookedSlotsInDay,
  noMargins,
  compactUI = false,
  cancelledCount,
  showCancelledOnly,
  setShowCancelledOnly,
  showCancelledChip = false,
  includeReportRelatedData,
  setIncludeReportRelatedData,
  hideToggleSwitchForReportRelatedData,
  selectedFilterType = 'all', // 'all', 'inPerson', 'video'
  setSelectedFilterType,
  onOpenBookedSlotsDrawer,
  // Opt-in compact layout: label on the first line, count beneath — narrower pills.
  stacked = false,
  // Opt-in: hide the "All Patients" (total) pill. Used by the slim mobile filter strip where the
  // In Person / Video pills toggle back to "all" on their own, so the total pill is redundant.
  hideAllTag = false,
  // Opt-in: drop the completed/total count from each pill, leaving just the modality icon — the
  // clean, count-free look used by the mobile strip.
  hideCounts = false,
  // Opt-in: show only the total appointment count (e.g. "3") beneath each pill instead of the
  // "completed/total" fraction. Used by the mobile strip.
  totalCountsOnly = false,
  // Opt-in: collapse the In Person + Video pills into a single, non-interactive summary card
  // showing completed/total (e.g. "2 / 5") — the day's progress at a glance on the mobile strip,
  // where per-modality filtering isn't useful.
  combinedSummary = false,
  // Opt-in: drop a modality pill entirely when its total is 0 (e.g. hide Video on an all-in-person
  // day) so the strip only shows what's relevant.
  hideZeroModalities = false,
}) => {
  const renderCount = (text) =>
    hideCounts ? null : <span className="chip-count">{stacked ? text : `(${text})`}</span>
  const countText = (finished, total) => (totalCountsOnly ? `${total}` : `${finished}/${total}`)
  const countInPerson = (bookedSlotsInDay || [])?.filter(
    (item) => item?.meetingSrc === SESSION_PLATFORM_OFFLINE,
  )?.length
  const finishedCountInPerson = (bookedSlotsInDay || [])?.filter(
    (item) => item?.meetingSrc === SESSION_PLATFORM_OFFLINE && item?.markedCompleted,
  )?.length
  const countVideo = (bookedSlotsInDay || [])?.filter(
    (item) => item?.meetingSrc === SESSION_PLATFORM_ONLINE,
  )?.length
  const finishedCountVideo = (bookedSlotsInDay || [])?.filter(
    (item) => item?.meetingSrc === SESSION_PLATFORM_ONLINE && item?.markedCompleted,
  )?.length

  return (
    <EDVCEventsContainer
      style={{ margin: noMargins ? '0' : '0', width: compactUI ? 'unset' : '100%' }}
    >
      {combinedSummary ? (
        <FilterTag
          as="div"
          $stacked={stacked}
          style={{ cursor: 'default' }}
          title="Completed / total appointments today"
        >
          <span className="chip-main">
            <ChairIcon />
            <VideoCameraFrontIcon />
          </span>
          <span className="chip-count">
            {`${finishedCountInPerson + finishedCountVideo} / ${countInPerson + countVideo}`}
          </span>
        </FilterTag>
      ) : (
        <>
          {!hideAllTag && (
            <FilterTag
              $stacked={stacked}
              selected={selectedFilterType === 'all'}
              onClick={() => {
                if (setSelectedFilterType) setSelectedFilterType('all')
                if (onOpenBookedSlotsDrawer) onOpenBookedSlotsDrawer()
              }}
            >
              <span className="chip-main">
                <Groups />
                <span className="chip-label">All Patients</span>
              </span>
              {renderCount(countText(finishedCountInPerson + finishedCountVideo, countInPerson + countVideo))}
            </FilterTag>
          )}
          {(!hideZeroModalities || countInPerson > 0) && (
            <FilterTag
              $stacked={stacked}
              selected={selectedFilterType === 'inPerson'}
              onClick={() => {
                if (setSelectedFilterType) setSelectedFilterType('inPerson')
                if (onOpenBookedSlotsDrawer) onOpenBookedSlotsDrawer()
              }}
            >
              <span className="chip-main">
                <ChairIcon />
                <span className="chip-label">In Person</span>
              </span>
              {renderCount(countText(finishedCountInPerson, countInPerson))}
            </FilterTag>
          )}
          {(!hideZeroModalities || countVideo > 0) && (
            <FilterTag
              $stacked={stacked}
              selected={selectedFilterType === 'video'}
              onClick={() => {
                if (setSelectedFilterType) setSelectedFilterType('video')
                if (onOpenBookedSlotsDrawer) onOpenBookedSlotsDrawer()
              }}
            >
              <span className="chip-main">
                <VideoCameraFrontIcon />
                <span className="chip-label">Video Call</span>
              </span>
              {renderCount(countText(finishedCountVideo, countVideo))}
            </FilterTag>
          )}
        </>
      )}
      {showCancelledChip && (
        <ActionButton
          $stacked={stacked}
          selected={showCancelledOnly}
          onClick={() => setShowCancelledOnly((prev) => !prev)}
        >
          <span className="chip-main">
            <DoNotDisturb />
            <span className="chip-label">Cancelled</span>
          </span>
          {renderCount(`${cancelledCount}`)}
        </ActionButton>
      )}
      {!hideToggleSwitchForReportRelatedData && (
        <ActionButton
          $stacked={stacked}
          selected={includeReportRelatedData}
          onClick={() => setIncludeReportRelatedData((prev) => !prev)}
        >
          <span className="chip-main">
            {includeReportRelatedData ? <CheckCircleIcon /> : <></>}
            <span className="chip-label">Show Reports Data</span>
          </span>
        </ActionButton>
      )}
    </EDVCEventsContainer>
  )
}

// {cancelledCount > 0 && (
//                   <div>
//                     <div
//                       style={{ cursor: 'pointer' }}
//                       onClick={() => setShowCancelledOnly((prev) => !prev)}
//                     >
//                       <u>{showCancelledOnly ? 'Show Booked' : 'Show Cancelled Only'}</u>
//                     </div>
//                     <div>Cancelled: {cancelledCount}</div>
//                   </div>
//                 )}

export const EventSelectorForBooking = ({
  selectedEventTypeId,
  eventTypesVisible,
  setSelectedEventTypeId,
  clinicLocationId,
  mentorProfileData,
}) => {
  const CHOSEN_BLOCK_VIDEO = 'video-block'
  const CHOSEN_BLOCK_IN_PERSON = 'in-person-block'
  const CHOSEN_BLOCK_OTHER = 'other-block'

  const [chosenBlockId, setChosenBlockId] = useState()
  const [inPersonBlock, setInPersonBlock] = useState()
  const [videoBlock, setVideoBlock] = useState()
  const [otherOptionsArray, setOtherOptionsArray] = useState([])

  useEffect(() => {
    const defaultEventTypeData = getInitiallySelectedEventTypeData(
      eventTypesVisible,
      clinicLocationId,
    )
    if (defaultEventTypeData) {
      let eventTypesForOther = [...eventTypesVisible]
      let eventTypesForInPerson = eventTypesForOther?.filter(
        (item) => item?.meetingSrc === SESSION_PLATFORM_OFFLINE,
      )
      let eventTypesForVideo = eventTypesForOther?.filter(
        (item) => item?.meetingSrc === SESSION_PLATFORM_ONLINE,
      )

      let defaultOrFirstInPersonEventData =
        eventTypesForInPerson?.find((item) => item.uid === defaultEventTypeData?.uid) ||
        eventTypesForInPerson[0]
      let defaultOrFirstVideoEventData =
        eventTypesForVideo?.find((item) => item.uid === defaultEventTypeData?.uid) ||
        eventTypesForVideo[0]

      if (defaultOrFirstInPersonEventData) {
        setInPersonBlock(defaultOrFirstInPersonEventData)
      }
      if (defaultOrFirstVideoEventData) {
        setVideoBlock(defaultOrFirstVideoEventData)
      }
      if (defaultOrFirstInPersonEventData) {
        eventTypesForOther = eventTypesForOther?.filter(
          (item) => item?.uid !== defaultOrFirstInPersonEventData?.uid,
        )
      }
      if (defaultOrFirstVideoEventData) {
        eventTypesForOther = eventTypesForOther?.filter(
          (item) => item?.uid !== defaultOrFirstVideoEventData?.uid,
        )
      }
      setOtherOptionsArray(eventTypesForOther)

      if (defaultOrFirstInPersonEventData && defaultOrFirstVideoEventData) {
        if (defaultEventTypeData?.uid === defaultOrFirstInPersonEventData?.uid) {
          setChosenBlockId(CHOSEN_BLOCK_IN_PERSON)
        } else if (defaultEventTypeData?.uid === defaultOrFirstVideoEventData?.uid) {
          setChosenBlockId(CHOSEN_BLOCK_VIDEO)
        } else {
          setChosenBlockId(CHOSEN_BLOCK_IN_PERSON)
        }
      } else if (defaultOrFirstInPersonEventData) {
        setChosenBlockId(CHOSEN_BLOCK_IN_PERSON)
      } else if (defaultOrFirstVideoEventData) {
        setChosenBlockId(CHOSEN_BLOCK_VIDEO)
      }
    }
  }, [])

  if (!Boolean(eventTypesVisible)) {
    return <div style={{ color: 'red' }}>No events offered in this location by mentor</div>
  }
  if (Array.isArray(eventTypesVisible) && eventTypesVisible.length === 0) {
    return <div style={{ color: 'red' }}>No events offered in this location by mentor</div>
  }

  if (inPersonBlock || videoBlock) {
    return (
      <div>
        <div className="d-flex gap-2">
          {inPersonBlock && (
            <BlockComponent
              selected={chosenBlockId === CHOSEN_BLOCK_IN_PERSON}
              clickFunction={() => {
                setChosenBlockId(CHOSEN_BLOCK_IN_PERSON)
                setSelectedEventTypeId(inPersonBlock?.uid)
              }}
              text={'In Person'}
              text2={`${inPersonBlock?.durationInMins}m`}
              icon={<ChairIcon />}
            />
          )}
          {videoBlock && (
            <BlockComponent
              selected={chosenBlockId === CHOSEN_BLOCK_VIDEO}
              clickFunction={() => {
                setChosenBlockId(CHOSEN_BLOCK_VIDEO)
                setSelectedEventTypeId(videoBlock?.uid)
              }}
              text={'Video'}
              text2={`${videoBlock?.durationInMins}m`}
              icon={<VideoCameraFrontIcon />}
            />
          )}
          {Array.isArray(otherOptionsArray) && otherOptionsArray.length > 0 && (
            <BlockComponent
              selected={chosenBlockId === CHOSEN_BLOCK_OTHER}
              clickFunction={() => {
                setChosenBlockId(CHOSEN_BLOCK_OTHER)
              }}
              text={'Other'}
              text2={'Sessions'}
            />
          )}
        </div>
        {chosenBlockId === CHOSEN_BLOCK_OTHER && (
          <>
            <div style={{ fontSize: '12px', marginTop: '16px' }}>Select session type:</div>
            <FormControl fullWidth>
              <MuiSelect
                labelId="select-event-type-label"
                id="select-event-type"
                value={selectedEventTypeId}
                label="Session Type"
                onChange={(e) => setSelectedEventTypeId(e.target.value)}
                sx={{ height: '32px', marginTop: '8px' }}
              >
                {otherOptionsArray?.map((eventType, eventTypeIndex) => {
                  return (
                    <MenuItem key={eventTypeIndex} value={eventType?.uid}>
                      {eventType?.title}
                      <span style={{ marginLeft: '12px' }}>
                        {'('}
                        {eventType?.durationInMins}
                        {' mins)'}
                      </span>
                      <span style={{ marginLeft: '12px' }}>
                        {eventType?.meetingSrc === SESSION_PLATFORM_OFFLINE && <ChairIcon />}
                        {eventType?.meetingSrc === SESSION_PLATFORM_ONLINE && (
                          <VideoCameraFrontIcon />
                        )}
                      </span>
                    </MenuItem>
                  )
                })}
              </MuiSelect>
            </FormControl>
          </>
        )}
      </div>
    )
  } else {
    return <></>
  }
}

const BlockComponent = ({ selected, text, text2, icon, clickFunction }) => {
  return (
    <div
      style={{
        cursor: 'pointer',
        background: selected ? '#7450aa' : '#fff',
        border: '1px solid #7450aa',
        color: selected ? '#fff' : '#7450aa',
        borderRadius: '4px',
        padding: '8px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '75px',
      }}
      onClick={() => clickFunction()}
    >
      <div>{icon}</div>
      <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{ marginTop: '4px' }}
      >
        <div style={{ fontSize: '12px' }}>{text}</div>
        <div style={{ fontSize: '10px' }}>{text2}</div>
      </div>
    </div>
  )
}

function cleanAttendantsArray(attendantsArray) {
  if (Array.isArray(attendantsArray)) {
    return attendantsArray.filter((item) => item?.name)
  }
  return []
}

export function giveTodayYesterdayElseFormattedStringPerLocal(
  utcTime,
  format,
  includeTime = false,
) {
  if (!format) {
    format = 'DD MMM YY hh:mm a' // Default format
  }

  const localDate = dayjs.utc(utcTime).local()
  const now = dayjs().local()

  const timeFormat = includeTime ? 'hh:mm a' : ''

  // Check if the date is today or yesterday
  if (localDate.isSame(now, 'day')) {
    return localDate.format(`[Today] ${timeFormat}`).trim()
  } else if (localDate.isSame(now.subtract(1, 'day'), 'day')) {
    return localDate.format(`[Yesterday] ${timeFormat}`).trim()
  } else {
    return localDate.format(format) // Otherwise, return the formatted date
  }
}

export const VitalsComponentInsideNewBooking = ({
  patientId,
  clinicId,
  practitionerId,
  withCreateButton,
  vitalsFormGetApiSignature,
}) => {
  const [loadingVitals, setLoadingVitals] = useState(false)
  const [vitalForThisBooking, setVitalForThisBooking] = useState()
  const [createDialogOpen, setCreateDialogOpen] = useState(false)

  async function getAndSetTodayVitals() {
    setLoadingVitals(true)
    const vital = await getPatientVitalForBookedEvent(patientId, clinicId, null, true)
    setLoadingVitals(false)
    console.log(vital)
    if (vital && isSameDayVital(vital) && isVitalObjectValid(vital)) {
      setVitalForThisBooking(vital)
    }
  }

  useEffect(() => {
    getAndSetTodayVitals()
  }, [patientId, clinicId])

  // Build API signature - use provided one or construct from practitionerId and clinicId
  const finalVitalsFormGetApiSignature = vitalsFormGetApiSignature || 
    (practitionerId && clinicId 
      ? `/api/secure/clinic-assistant/vitals/form?practitionerId=${practitionerId}&clinicLocationId=${clinicId}`
      : '/api/secure/practitioner/vitals/form')

  return (
    <div>
      <div>
        <span>
          <b>Vitals: </b>
        </span>
        {loadingVitals ? (
          <>
            <Spinner size="sm" variant="dark" />
          </>
        ) : (
          <>
            {!Boolean(vitalForThisBooking) && withCreateButton && (
              <span
                style={{ cursor: 'pointer', fontSize: '12px' }}
                onClick={() => setCreateDialogOpen(true)}
              >
                <u>Record Now</u>
              </span>
            )}{' '}
          </>
        )}
      </div>
      <div className="w-100 d-flex gap-2" style={{ overflow: 'auto' }}>
        {vitalForThisBooking ? (
          <VitalShowingComponent vitalItem={vitalForThisBooking} />
        ) : (
          'No Vitals recorded'
        )}
      </div>
      {createDialogOpen && (
        <VitalsComponentEntryDialog
          patientId={patientId}
          clinicId={clinicId}
          vitalsFormGetApiSignature={finalVitalsFormGetApiSignature}
          closeFunction={() => setCreateDialogOpen(false)}
          callbackFunctionAfterSave={() => {
            setCreateDialogOpen(false)
            getAndSetTodayVitals()
          }}
        />
      )}
    </div>
  )
}

// // //
export function isWithinLast24Hours(startTime) {
  const startDate = new Date(startTime + ' UTC')

  const currentUtcDate = new Date()

  const differenceInMs = currentUtcDate - startDate

  return differenceInMs <= 24 * 60 * 60 * 1000
}

function isSameDayVital(vitalItem) {
  const createdDate = dayjs?.utc(vitalItem?.createdTime)
  const currentDate = dayjs()
  const isSameDay = createdDate.isSame(currentDate, 'day')
  return isSameDay
}

// Enhanced Phone Input Component with proper validation and country enforcement
export function CMBCEnhancedPhoneInput({
  value,
  onChange,
  disabled = false,
  placeholder = 'Mobile Number',
  allowedCountries = null,
  inputProps = {},
  onFocus = null,
  onBlur = null,
  onKeyDown = null,
  fullWidth = false,
  containerStyle = {},
  inputStyle = {},
}) {
  const { unSecureSetupData } = useContext(UnsecureSetupContext)
  const [validationState, setValidationState] = useState({
    isValid: false,
    error: null,
    formattedNumber: null,
    country: null,
  })

  // Get supported countries from metaCountries or fallback to common ones
  const supportedCountries = useMemo(() => {
    if (allowedCountries) return allowedCountries

    // Extract country codes from metaCountries if available
    const metaCountryCodes = unSecureSetupData?.metaCountries?.map((country) =>
      country.id.toUpperCase(),
    )

    // Fallback to common countries if metaCountries not available
    return (
      metaCountryCodes || ['IN', 'US', 'GB', 'CA', 'AU', 'SG', 'AE', 'MY', 'NZ', 'DE', 'FR', 'JP']
    )
  }, [allowedCountries, unSecureSetupData?.metaCountries])

  // Determine default country
  const getDefaultCountry = () => {
    const storedCountry = localStorage.getItem('countryCode')?.toLowerCase()
    if (storedCountry && supportedCountries.includes(storedCountry.toUpperCase())) {
      return storedCountry
    }
    return 'in' // Fallback to India
  }

  // Validate phone number using libphonenumber-js
  const validatePhoneNumber = (phoneValue) => {
    if (!phoneValue || phoneValue.length < 5) {
      return {
        isValid: false,
        error: null, // Don't show error for empty/short inputs
        formattedNumber: null,
        country: null,
      }
    }

    try {
      // Ensure the phone number has a + prefix for international format
      const phoneWithPlus = phoneValue.startsWith('+') ? phoneValue : `+${phoneValue}`

      // Parse the phone number
      const phoneNumber = parsePhoneNumber(phoneWithPlus)

      if (!phoneNumber) {
        return {
          isValid: false,
          error: 'Invalid phone number format',
          formattedNumber: null,
          country: null,
        }
      }

      // Check if country is supported (only if we have country restrictions)
      if (
        supportedCountries &&
        supportedCountries.length > 0 &&
        !supportedCountries.includes(phoneNumber.country)
      ) {
        const countryName =
          unSecureSetupData?.metaCountries?.find(
            (c) => c.id.toLowerCase() === phoneNumber.country.toLowerCase(),
          )?.name || phoneNumber.country

        return {
          isValid: false,
          error: `${countryName} is not supported. Please select a supported country.`,
          formattedNumber: phoneNumber.formatInternational(),
          country: phoneNumber.country,
        }
      }

      // Validate the number
      if (!phoneNumber.isValid()) {
        return {
          isValid: false,
          error: 'Invalid phone number for the selected country',
          formattedNumber: phoneNumber.formatInternational(),
          country: phoneNumber.country,
        }
      }

      return {
        isValid: true,
        error: null,
        formattedNumber: phoneNumber.formatInternational(),
        country: phoneNumber.country,
        e164: phoneNumber.format('E.164'), // Standard international format
      }
    } catch (error) {
      console.warn('Phone validation error:', error)
      return {
        isValid: false,
        error: 'Invalid phone number',
        formattedNumber: null,
        country: null,
      }
    }
  }

  // Handle phone number change
  const handlePhoneChange = (newValue) => {
    // Call onChange immediately with the raw value to maintain UX
    if (onChange) {
      onChange(newValue)
    }

    // Validate and update state
    const validation = validatePhoneNumber(newValue)
    setValidationState(validation)
  }

  // Validate on value change
  useEffect(() => {
    if (value) {
      const validation = validatePhoneNumber(value)
      setValidationState(validation)
    } else {
      setValidationState({ isValid: false, error: null, formattedNumber: null, country: null })
    }
  }, [value, supportedCountries])

  return (
    <div className="d-flex flex-column">
      <EDVCPhoneInput
        inputProps={inputProps}
        disabled={disabled}
        specialLabel=""
        placeholder={placeholder}
        containerStyle={{
          width: '100%',
          maxWidth: fullWidth ? '100%' : undefined,
          ...containerStyle,
        }}
        inputStyle={{
          width: '100%',
          ...inputStyle,
        }}
        country={getDefaultCountry()}
        // Only show supported countries in dropdown if we have restrictions
        onlyCountries={
          supportedCountries ? supportedCountries.map((code) => code.toLowerCase()) : undefined
        }
        value={removePlusFromBeginning(value || '')}
        onChange={handlePhoneChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
      />

      {/* Validation feedback */}
      {validationState.error && (
        <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '4px' }}>
          {validationState.error}
        </div>
      )}

      {/* Success feedback */}
      {validationState.isValid && validationState.formattedNumber && (
        <div style={{ color: '#2e7d32', fontSize: '12px', marginTop: '4px' }}>
          ✓ {validationState.formattedNumber}
        </div>
      )}
    </div>
  )
}
